import { commaedInteger, formatDigits } from '../scripts/weapp-commons/util/string-util';
/**
 * @generated
 */

export const textJa = {
  c: `予約手数料100%`,
  liquidProductsNotice: (className: string) =>
    `ご注意！ ※景品には<span class=${className}>液体商品が含まれること</span>があります。受け取った商品を<span class=${className}>手荷物預けすること</span>をご検討ください`,
  airports: {
    airportSwitched: `受取り場所を変更しました。`,
    areYouSureToSwitchAirport: `受け取る店舗を切り替えますか？`,
    map: `地図`,
    mapTitle: (shop: string) => `${shop}の受取り場所の説明`,
    metaDescription: (shop: string) =>
      `日本旅行のお土産をもっと楽に、お得に買うなら、WAmazingオンライン免税店！買った商品を直接${shop}で受け取れる。`,
    pickupAirport: `受け取る場所`,
    selectPickupAirport: `受け取る場所を選ぶ`,
    switchingAirportWouldClearCart: `店舗を切り替えると、カートがクリアされます`
  },
  allVisitorCampaign: {
    allYouCanUse: (highlight: string, currency: string) =>
      `誰でも使える<span class=${highlight}>1,000<span class=${currency}>円</span>OFF</span>`,
    click: `クリック`,
    getCoupon: `クーポンをゲット`,
    getSoon: `今すぐゲット`
  },
  amounts: {
    checkVendorAmount: `販売主ごとの合計金額をご確認ください`,
    consumptionTax: `消費税`,
    discounted: `ディスカウント`,
    drugPurchasableAnnotation: `スギ薬局のカート内合計金額が1000円を超えると購入可能です。`,
    explanationOfLocalCurrencyAmount: (date: string) =>
      `※日本円以外の単価は ${date} 通貨レートで計算された参考金額。\nお客様の実際の支払金額は支払いサービスによって決められる。`,
    maximumTotalAmountIs500000JPY: `最大オーダー金額は500,000JPY`,
    minimalTotalAmountIs1000Jpy: `1000円以上で購入可能`,
    minimalTotalAmountIs3000Jpy: `3000円以上で購入可能`,
    minimalTotalAmountIs5000Jpy: `最低オーダー金額が5,000JPY`,
    orderAmount: `オーダー金額`,
    purchaseAmount: `お支払い金額`,
    shopDiscountAmount: `入場券割引`,
    subtotalAmount: `小計`,
    taxFree: `免税`,
    taxFreeIfTotalAmountExceeds5kJpy: `商品合計5,000JPY超えると、消費税免除されます。`,
    totalAmount: `合計金額`
  },
  announce: {
    noteText: `※物流の年末年始休暇に伴い、12/30〜1/7に商品受け取り希望の方は、現在注文ができません。1/8以降の受け取りは通常の規定通り注文を受け付けております。`
  },
  auth: {
    accountNotYet: `アカウントはまだないですか？`,
    creditCardList: `クレジットカード管理`,
    lookForwardToServingYouAgain: `またのご利用をお待ちしております。`,
    signIn: `ログイン`,
    signUp: `登録`,
    signUpNow: `今すぐ登録`,
    signedOut: `ログアウトしました。`,
    signUpCoupon: {
      alt: `500円OFF`,
      getNow: `今すぐ受け取る`,
      title: `新しく加入した会員`
    }
  },
  banner: {
    cosmetics: {
      featured: `特集`,
      mustBuy: `Must-Buy Items`,
      postCovid: `Afterコロナの必需品`
    },
    skincare: {
      recommended: `編集部おすすめ\n人気単品`,
      specialSet: `夏のスキンケア\n特集`
    },
    snacks: {
      haveATry: `味わってみる`,
      souvenirs: `お土産`
    },
    walkthrough: {
      amazingTaxFreeService: `新しい免税サービス`,
      onlyIn3min: `最短3分`,
      seeMoreAmazingSights: `観光を楽しめる`,
      title: `旅前に予約して、\n空港で受け取る`
    }
  },
  brands: {
    cosmeticBrand: `化粧品ブランド`,
    cosmeticBrandTitle: (cosmeticBrand: string) => `${cosmeticBrand}`,
    description: `ブランド一覧。日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`,
    searchResult: `検索結果`,
    titleName: `ブランド一覧`,
    viewAll: `全てのブランドをみる`,
    index: {
      strokeCount: `画`
    },
    list: {
      title: `ブランド一覧`
    },
    meta: {
      description: (brand: string) =>
        `${brand}の商品一覧。日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`,
      descriptionWithParams: (brand: string, category: string) =>
        `${brand} ${category}の商品一覧。日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`,
      title: (brand: string) => `${brand}の日本免税商品一覧`,
      titleWithParams: (brand: string, category: string) => `${brand} ${category}の日本免税商品一覧`
    },
    search: {
      placeholder: `ブランド名を入れてください`
    },
    slug: {
      description: (brand: string) =>
        `${brand}の商品一覧。日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`
    }
  },
  campaign: {
    present: `プレゼント`,
    bank: {
      esun: `玉山銀行クレカ決済なら最大25%OFFクーポン貰える`,
      taiwanMobile: `台湾モバイル利用なら最大2500円OFFクーポン貰える`,
      title: `お得なキャンペーン多数実施中！\nキャンペーンをこちらからチェック！`,
      ubot: (price: string, discount: string) =>
        `聯邦銀行クレカ決済なら${price}円以上のご利用で${discount}割引の特典が受けられます。`,
      yuanta: `元大銀行クレカ決済なら最大20%OFFクーポン貰える`
    },
    fancl: {
      addNowToCart: `今すぐカートに追加`,
      goodDealPrice: (price1: string, price2: string) => `通常 ${price1}円(税込)が今なら${price2}円お得`,
      limitedSpecialSet: `FANCL数量限定スペシャルセット`,
      specialSetPrice: `特別セット価格`,
      usageStep: `ご使用ステップ`,
      brighteningSet: {
        present: `＜プレゼント＞マイルドクレンジングオイル　120ml`,
        product1: `マイルドクレンジングオイル＜ブラック＆スムース＞ 120ml`,
        product2: `泥ジェル洗顔　120g`,
        product3: `ブライトニング 化粧液 II しっとり<医薬部外品> 30ml`,
        product4: `ブライトニングエッセンス<医薬部外品> 18ml`,
        product5: `ブライトニング 乳液 II しっとり<医薬部外品> 30ml`,
        product6: `ブライトニングマスク<医薬部外品> 6枚`,
        product7: `サンガード50+　プロテクトUV　60ml`,
        title: `美白セット`,
        whatMelanin: `＊1 美白とはメラニンの生成をおさえ、シミ・ソバカスを防ぐのこと\n（マイルドクレンジングオイル、泥ジェル洗顔、サンガード50＋プロテクトUV除く）`
      },
      og: {
        description: `WAmazing初の数量限定スペシャルセット！ お得に買うなら、WAmazingオンライン免税店！`,
        title: `WAmazing初の数量限定スペシャルセット！ | WAmazing免税買い物サービス`
      },
      pores: {
        present: {
          description: `美容液のような「とろすべオイル」でこすらずオフ。毛穴の目立たないうるすべ素肌へ。`,
          name: `クレンジング`,
          title: `マイルドクレンジングオイル　60ml`
        },
        step1: {
          description: `毛穴汚れを一掃するパウダー状の酵素洗顔料。`,
          name: `洗顔`,
          title: `ディープクリア洗顔パウダー 30個`
        },
        step2: {
          description: `はがさず、流すだけ。毛穴の黒ずみを5分でスッキリ！`,
          name: `クレンジング`,
          title: `ポアクレンジングパック　40g`
        },
        step3: {
          description: `気になる毛穴の原因に着目。テカリを防ぎサラサラな肌へ整える部分用美容液`,
          name: `毛穴美容液`,
          title: `ポアエッセンス 8g`
        },
        step4: {
          description: `毎日使いで毛穴汚れやザラつきをすっきりオフ。`,
          name: `洗顔`,
          title: `泥ジェル洗顔　120g`
        },
        step5: {
          description: `美容液のような「とろすべオイル」でこすらずオフ。毛穴の目立たないうるすべ素肌へ。`,
          name: `クレンジング`,
          title: `マイルドクレンジングオイル　120ml`
        },
        step6: {
          description: `「小鼻の汚れが気になる」「今よりももっとツルツル素肌をめざしたい」など、とにかく毛穴ケアを求める方に！`,
          name: `クレンジング`,
          title: `マイルドクレンジングオイル＜ブラック＆スムース＞120ml`
        }
      },
      poresSet: {
        present: `＜プレゼント＞マイルドクレンジングオイル　60ml`,
        product1: `ディープクリア洗顔パウダー 30個`,
        product2: `ポアクレンジングパック　40g`,
        product3: `ポアエッセンス 8g`,
        product4: `泥ジェル洗顔　120g`,
        product5: `マイルドクレンジングオイル　120ml`,
        product6: `マイルドクレンジングオイル＜ブラック＆スムース＞ 120ml`,
        title: `毛穴セット`
      },
      present: {
        description: `美容液のような「とろすべオイル」でこすらずオフ。毛穴の目立たないうるすべ素肌へ。`,
        name: `クレンジング`,
        title: `マイルドクレンジングオイル　120ml`
      },
      step1: {
        description: `「小鼻の汚れが気になる」「今よりももっとツルツル素肌をめざしたい」など、とにかく毛穴ケアを求める方に！`,
        name: `クレンジング`,
        title: `マイルドクレンジングオイル＜ブラック＆スムース＞120ml`
      },
      step2: {
        description: `毎日使いで毛穴汚れやザラつきをすっきりオフ。`,
        name: `洗顔`,
        title: `泥ジェル洗顔　120g`
      },
      step3: {
        description: `すこやかで透明感あふれる素肌へ整える、しっとりタイプの薬用美白化粧液。`,
        name: `化粧液`,
        title: `ブライトニング 化粧液 II しっとり<医薬部外品> 30ml`
      },
      step4: {
        description: `シミの根本にアプローチし、透明美肌へ`,
        name: `美容液`,
        title: `ブライトニングエッセンス<医薬部外品> 18ml`
      },
      step5: {
        description: `うるおい続く明るい透明美肌に整える、しっとりタイプの薬用美白乳液`,
        name: `乳液`,
        title: `ブライトニング 乳液 II しっとり<医薬部外品> 30ml`
      },
      step6: {
        description: `マスク1枚に美白美容液1本分以上の美容液がたっぷり。`,
        name: `マスク`,
        title: `ブライトニングマスク<医薬部外品> 6枚`
      },
      step7: {
        description: `汗・水に強く、強い紫外線や外的刺激から肌をブロック！`,
        name: `日焼け止め`,
        title: `サンガード50+　プロテクトUV　60ml`
      }
    },
    jcb: {
      aboutFlow1: `<em>最短在希望取貨日的3天前</em><br>上網或使用APP完成預約購買`,
      aboutFlow2: `<em>所需時間約3分鐘！</em><br>前往置物櫃，<br>進行人臉辨識及護照確認，<br>即可完成免稅手續並結帳`,
      aboutFlow3: `領取放在<em>置物櫃</em>裡<br>的購入商品`,
      aboutNote: `（取貨地點可選擇日本全國指定的機場或是車站）`,
      aboutText: `利用於全國指定車站或機場內設置的<em>置物櫃型自動販賣機</em>，<br>即可領取已預約商品的線上免稅購物服務。`,
      flow1: `將合計<em>1萬日圓<sup>※</sup> 以上</em>的商品加入購物車後、點選<em>購物車圖示按鈕</em>，進到結帳畫面`,
      flow2: `按下詳細金額旁邊的「<em>選擇優惠券</em>」（英語則是「<em>Select Coupon</em>」），選擇並輸入上面的優惠券代碼`,
      flow3: `於下一個結帳畫面選擇「<em>JCB</em>」，完成預約購買`,
      meta: `JCB會員限定企劃！只要購物1萬日圓以上，就能折抵免稅商品2,000日圓`,
      noteForCondition: `※此為折扣前的金額　\n※部分商品不適用此折扣活動`,
      noteForFlow: `※1萬日圓以上的訂單內容皆須為適用折扣的商品`,
      period: `2023年10月16日（一）  〜 2024年1月15日（一） （台灣時間22:59為止）`,
      shoppingTitle: `即將接近一年的尾聲，看看有哪些適合拿來送禮的美食伴手禮`,
      banner: {
        notice: `※不適用JCB優惠券`,
        title: `WAmazing 其他服務`
      },
      notes: {
        note1: `・除日本及香港發行的卡，其餘國家及地區的JCB信用卡皆為適用對象。`,
        note10: `・參加本活動的貴賓，即代表同意將個人資訊提供給完美行以及JCB International Inc.。`,
        note2: `・需使用JCB信用卡結帳。`,
        note3: `・優惠券1人僅限使用1次。`,
        note4: `・優惠券無法併用。`,
        note5: `・優惠券的使用期限至日本時間2024年1月15日23:59。`,
        note6: `・無法將本活動的權利轉讓給他人，亦無法轉換成現金。`,
        note7: `・本活動可能會在未事先通知的情況下變更活動內容或終止活動，敬請見諒。`,
        note8: `・部分商品不適用本活動。`,
        note9: `・將於資訊公開時，一併記載確切的活動舉辦期間。\n本活動有可能於上述時間結束後仍持續進行。`
      },
      shopping: {
        brandTitle153: `〈正品〉資生堂`,
        brandTitle426: `〈正品〉SK-II`,
        brandTitle7558: `柿之種米果`,
        brandTitle8472: `瀨戶內檸檬農園`,
        brandTitle9422: `沖繩南風堂`,
        brandTitle9516: `巖手屋`,
        brandTitle9538: `〈正品〉FANCL`,
        brandTitle9597: `〈正品〉黛珂`,
        catch153: `高人氣抗老護理保養品`,
        catch426: `SK-II熱銷品`,
        catch6842: `北海道品牌`,
        catch6937: `送禮人氣No.1`,
        catch7534: `門市熱銷不斷`,
        catch7558: `東京限定`,
        catch7696: `內含皇冠哈密瓜果肉`,
        catch8472: `來自檸檬產量日本第一的廣島`,
        catch9422: `來自沖繩縣、回購不斷的勁辣好滋味`,
        catch9516: `岩手知名甜點`,
        catch9538: `完美行限定的正品`,
        catch9597: `獲獎無數的熱銷美妝No.1`,
        description153: `打造水潤彈力肌膚的美容晚霜。好推不黏膩，能確實服貼肌膚。`,
        description426: `SK-II 最暢銷的美白精華液。防止肌膚因為紫外線而產生斑點及暗沉，打造由內到外的透亮肌膚。`,
        description6842: `加入大量北海道牛奶的「牛奶口味」、以及搭配知名的高級抹茶產地——西尾產抹茶的「抹茶牛奶口味」，總計共6種口味！`,
        description6937: `小包裝設計，一次享用五種口味，最適合拿來當伴手禮！`,
        description7534: `由熟悉起司的專業職人們監製，打造出味道、香氣、口感皆十分講究的起司點心。`,
        description7558: `甜辣天丼風味、文字燒風味、濃厚法式多蜜醬風味、高湯咖哩風味，每種風味各有4包`,
        description7696: `加入最高級的哈密瓜——皇冠哈密瓜果肉的果凍與布丁組合`,
        description8472: `外頭酥脆、中間鬆軟。有著清爽檸檬風味且不會過甜，嚐過就停不下來的美味，非常推薦於下午茶時享用。`,
        description9422: `辛辣口感讓人無法抗拒。加入沖繩島唐辛子的酥脆蝦餅`,
        description9516: `以小麥及芝麻為材料，再加上少許的鹽，製作出擁有樸素的基本口味，並搭配各種材料變化出不同風味的南部煎餅。`,
        description9538: `推薦給零毛孔肌膚的卸妝油及精華液5款商品組合。現在購買還多贈送1罐卸妝油。`,
        description9597: `多次榮獲最佳美妝大賞No.1！即使睡眠不足，肌膚看起來仍像是多睡3小時般亮麗的修復霜。`,
        moreButton1: `編輯部推薦伴手禮`,
        moreButton2: `查看更多日本全國伴手禮`,
        moreButton3: `查看更多推薦商品`,
        notice: `※目前以2023年8月底的匯率做計算。實際購買金額以購買當下的最新匯率為準。`,
        sectionTitle1: `即將接近一年的尾聲，看看有哪些適合拿來送禮的美食伴手禮`,
        sectionTitle2: `日本人超推！只有當地才買得到的伴手禮`,
        sectionTitle3: `現在買最划算的必買商品`,
        text153: `怡麗絲爾 膠原緊膚晚霜 W`,
        text426: `超肌因鑽光淨白精華 30ml`,
        text6842: `LANGUE DE CHAT 30片混裝`,
        text6937: `薯條餅乾迷你禮盒 10入`,
        text7534: `起司奶油脆餅 12塊裝`,
        text7558: `東京限定　龜田土產柿之種`,
        text7696: `靜岡皇冠哈密瓜果凍 8個入（含3支特製金湯匙）`,
        text8472: `銀鈴檸檬蛋糕`,
        text9422: `島唐辛子辣味蝦餅（小）`,
        text9516: `Nico Nico 南部煎餅`,
        text9538: `【毛孔淨化套組】`,
        text9597: `Liposome Advanced Repair Cream 50g`
      }
    }
  },
  cart: {
    addToCart: `カートに入れる`,
    addedToCart: `カートに入れました`,
    cartCollections: `カート一覧`,
    cartIsEmpty: `カートにまだ商品がありません。`,
    cartIsEmptyToTop: `TOPへ戻る`,
    cartIsEmptyToTopAndAddProducts: `TOPに戻って\nお気に入りの商品を追加してください。`,
    continueShopping: `買い物を続ける`,
    detail: `金額詳細`,
    insufficientAmountToPurchase: (insufficientAmount: number) => `あと${insufficientAmount}円追加で注文可能`,
    proceedToForm: `注文フォームへ進む`,
    purchasable: `注文可能`,
    showToCart: `カートを見る`,
    taxFreeShopOrderingCondition: (shopName: string) => `${shopName}の購入下限金額が5000円(割引後)`,
    taxableShopOrderingCondition: (shopName: string) => `${shopName}の購入下限金額が1000円`,
    title: `カート詳細`,
    agree: {
      addToCart: `同意してカート追加`
    },
    cannotPickup: {
      removeItem: `受取り不可で、削除してください。`
    },
    confirm: {
      addToCart: `確認してカートに追加`,
      checkNotes: {
        addToCart: `注意事項を確認してカート追加`
      }
    }
  },
  cartError: {
    productNotOrderable: `商品準備中`
  },
  category: {
    largeCategoryDescription: (largeCategory: string) =>
      `可日本の有名な人気${largeCategory}をオンラインで購入し、日本の空港で受け取ることができます。WAmazingオンライン免税店を使って、日本旅行のお土産ショッピングをもっと楽に、もっとお得に！`,
    middleCategoryDescription: (middleCategory: string, largeCategory: string) =>
      `日本の有名な人気${middleCategory} ${largeCategory}をオンラインで購入し、日本の空港で受け取ることができます。WAmazingオンライン免税店を使って、日本旅行のお土産ショッピングをもっと楽に、もっとお得に！`,
    middleCategoryMetaTitle: (middleCategory: string, largeCategory: string) =>
      `日本必買${middleCategory}・${largeCategory}`,
    popularSmallCategory: `人気の小カテゴリ`,
    showVendorOnlyDrug: `スギ薬局 川口戸塚店`,
    smallCategoryDescription: (smallCategory: string, middleCategory: string) =>
      `日本の有名な人気${smallCategory} ${middleCategory}をオンラインで購入し、日本の空港で受け取ることができます。WAmazingオンライン免税店を使って、日本旅行のお土産ショッピングをもっと楽に、もっとお得に！`,
    smallCategoryMetaTitle: (smallCategory: string, middleCategory: string) =>
      `日本必買${smallCategory}・${middleCategory}`,
    title: `カテゴリ`,
    meta: {
      description: (categoryName: string) =>
        `${categoryName}の商品一覧。日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`,
      title: (categoryName: string) => `${categoryName}の日本免税商品一覧`
    }
  },
  categoryRanking: {
    seeMore: `ランキングをもっとみる`,
    title: `カテゴリランキング`
  },
  commons: {
    after: (time: string) => `${time}過ぎ`,
    afterShipping: `出荷後`,
    all: `全部`,
    autoApplyDiscountOnAddToCart: `カート追加で自動的に適用されます`,
    autoApplyDiscountOnAddToCartDesc: `カート追加で自動的に適用されます。他クーポンとの併用も可能です`,
    automaticCancel: (time: string) => `${time}以降自動キャンセル`,
    before: `まで`,
    beforeShipping: `出荷前`,
    bestJapanese: `日本必買`,
    cancelFee: `キャンセル料`,
    choice: `選択`,
    cosmetics: `スキンケア・化粧品`,
    dateAndTime: (year: string, month: string, day: string, hour: string, minute: string) =>
      `${year}年${month}月${day}日 ${hour}時${minute}分から`,
    dismiss: `閉じる`,
    download: `ダウンロード`,
    errorOccurred: `エラー起こりました`,
    exclamationMark: `！`,
    foldContents: `折りたたむ`,
    goBack: `戻る`,
    hot: `人気`,
    lessThan: `以下`,
    mustBuy: `日本推薦`,
    noShow: `キャンセルせず、商品を受け取らなかった場合`,
    ok: `OK`,
    pinchOut: `ピンチアウトで拡大`,
    proceed: `進む`,
    purchaseTaxFree: `免税で購入`,
    qualities: `特徴`,
    quantity: `数`,
    remove: `削除`,
    showMore: `もっと見る`,
    showMoreDetails: `この商品を確認する`,
    signUp: `登録`,
    snacks: `お菓子`,
    specialDeals: `お買い得の情報`,
    tax: `税込み`,
    taxFreeProducts: `免税商品`,
    taxFreeRegularPrice: `通常価格(免税)`,
    taxFreeSalePrice: `セール価格(免税)`,
    taxProducts: `課税商品`,
    topPage: `TOPページ`,
    tryAgain: `恐れ入りますが、最初からやり直してください。`,
    undisclosed: `非公開`,
    until: (time: string) => `${time}まで`,
    vendor: `販売主`,
    wamazingShop: `WAmazing免税買い物サービス`,
    yen: `円`,
    aboutWamazingShop: {
      desc: `全国の駅や空港内などに設置されたロッカー型の自動販売機を利用して、帰国前などに商品を受け取ることができる。`,
      title: `Wamazing Shop とは？　`
    },
    campaign: {
      seeMoreDetail: `キャンペーン詳細はこちら`
    },
    date: {
      day: `日`,
      month: `月`,
      year: `年`
    },
    meta: {
      title: `日本への旅行で日本のお土産を免税で簡単に購入したいならWAmazing｜WAmazing`
    },
    notice: {
      notContainKobayashiPharmaceuticalBeniKoji: `WAmazingshopで取り扱っている商品につきまして、健康被害が報道されている小林製薬の紅麹原料は一切使用しておりません。`
    },
    url: {
      copied: `URLがコピーされました`
    }
  },
  complementary: {
    addNToCart: (count: number) => `${count}点をカートに追加`,
    addToCart: `カートに追加`,
    count: (count: number) => `${count}点の小計`,
    title: `一緒に購入されている商品`,
    viewDetail: `詳細を確認`
  },
  counterPickup: {
    jttpRemark: `完美行購物はJTTPには現在対応しておりません。`,
    vjmGuideUrl: `https://services.digital.go.jp/zh-cmn-hant/visit-japan-web/guide/`,
    vjmRemark: (className: string, childClassName: string, url: string) =>
      `指定施設にて免税で商品を受け取るには、<span class=${className}>日本に入国後<a class=${childClassName} href=${url} target="_blank">VJW（Visit Japan Web）の登録</a>が必須</span>になります`,
    guide: {
      cancellationPolicy: {
        description: `予約時に支払った購入金額の20%相当をキャンセル料としていただきます。対面受け取りの場合は予約時に100%支払いをしているのでキャンセル時点で80%を返金いたします。`,
        refund: {
          description: `返金が発生する場合はキャンセルした時点で即時返金を行います。ご利用の支払い方法によっては、実際に返金が行われるまで時間がかかる場合がございます。返金はご利用いただいた支払い方法に紐づく形で返金されます。`
        }
      },
      caution: {
        text1: `空港を\n間違わないこと`,
        text2: `スケジュールを\n間違わないこと`,
        text3: `ロッカー受け取りの場合、パスポートを\n忘れないこと`,
        text4: `ネット環境を\nご用意すること`,
        title: `注意してほしいこと`
      },
      counter: {
        help: {
          description: `カスタマーサポートのスタッフが対応します`,
          descriptionDetail: (className: string) =>
            `受取でお困りの際は、スタッフが示す問い合わせ<span class=${className}>QRコード<span class=${className}>もしくはこちら（https://www.wamazing.com/kaimono/pickup_support）からWAmazingの<span class=${className}>カスタマーサポート</span>へお問い合わせください。`,
          title: `対面受取りで困ったら...`
        },
        step1: {
          description1: (className: string) =>
            `対面受取りにて免税手続きを行うために、あらかじめVisit Japan Webの<span class=${className}>登録</span>と<span class=${className}>免税QRコード</span>の作成が<span class=${className}>必須</span>となっています。`,
          description2: `Visit Japan Webとは？`,
          description3: `Visit Japan Web利用の流れを見る`,
          title: `入国前にVisit Japan Web(VJW)に登録`
        },
        step2: {
          description: (className: string) =>
            `商品の<span class=${className}>受け取り場所</span>と<span class=${className}>受取日</span>と<span class=${className}>時間</span>を指定`,
          title: `受け取り場所を選択`,
          button: {
            title: `対面の受け取り場所一覧`
          }
        },
        step3: {
          description1: `受け取りまでに免税QRコードを発行しておいてください`,
          title: `VJWで免税QRコードを発行`,
          button: {
            title: `免税QRコードの発行方法を確認`
          }
        },
        step4: {
          description: (className: string) =>
            `受け取りの際に「受取QRコード」とSTEP03で発行した「免税QRコード」をスタッフに提示して、商品を受け取ります。\n受取QRコードはマイページの購入履歴から確認できます。\nご不明点などあれば、現場のスタッフではなく、WAmazingの<span class=${className}>カスタマーサポート</span>へお問い合わせください。`,
          title: `商品の受取り`
        }
      },
      customerSupport: {
        description: `予期せぬトラブルなどで荷物が受け取れない場合、全額返金いたします。詳しくはカスタマーサポートへご相談ください。\n※お客様都合でのキャンセルは対象外です。公共交通機関の遅延の場合は遅延証明書をご提出いただくことで返金対応いたします。`,
        heading: `返金保証のご案内`,
        subHeading: `はじめての方も安心`,
        title: `万が一受け取りができなかった場合、全額返金！`
      },
      faq: {
        message1: `受け取りの際に何か必要？\n`,
        message10: `弊社が設置したロッカーはすべて駅や空港の建物内にあります。\nすべての受取手続きは、セキュリティチェックを通過する前（出国前）に完了している必要があります。\nチェックイン前にロッカーで荷物を受け取ることをお勧めします。\n※入国時受け取りされた場合は、入国手続き後に商品を受け取ることができます。\n※ご購入商品に100mlを超える液体が入っている場合は、お預けいただくことをおすすめいたします。\n\n詳しい受取場所や手続き方法については、以下のウェブサイトをご覧ください。\n<a href="https://tw.wamazing.com/kaimono/guide">https://tw.wamazing.com/kaimono/guide</a>\n※商品受取の際には、チップ付きパスポートと有効な入国許可シールが必要となります。`,
        message11: `受取端末の前で支払いを済ませたが、ロッカーの中に商品が入っていなかった。どうしたらよいか。`,
        message12: `ご迷惑をおかけして申し訳ありません。全額返金もしくはご自宅まで商品を郵送させていただきますので、大変お手数ですがカスタマーサポートまでお問い合わせください。\n<a href="https://tw.wamazing.com/kaimono/support">https://tw.wamazing.com/kaimono/support</a>`,
        message2: `【ロッカー受け取りの場合】\n顔認証と本人確認が必要があるため、必ず以下のものをご用意してください。\n\n①受け取り本人のIC付きのパスポート。（他人のパスポートをご利用いただけません）IC付きのパスポートを持ってない場合、受け取りできません。\n\n②上陸許可証\n※入国の際にパスポートに貼られます（to買い物チーム：サンプル画像追加可能でしょうか？上陸許可証はどういうものなのか分からないという人もいますのでｍｍ）\n※キャビンアテンダント、乗り継ぎの旅客、また日本の在留資格をお持ちで、入国の際に『上陸シール』が貼られてない場合（JTTP含め）はご利用できません\n\n③お支払いの際にネット通信が必要があるため、必ず通信できる携帯をご用意ください\n\n【対面受け取りの場合】\n①Visit Japan Webの免税QRコード\n事前に免税QRコードの作成をお願いいたします。\nhttps://services.digital.go.jp/visit-japan-web/guide\n\n②受け取りの際にネット通信が必要があるため、必ず通信できる携帯をご用意ください`,
        message3: `受け取り期間を過ぎた場合、どうなりますか。`,
        message4: `受け取り期間を一定期間過ぎた場合、キャンセル扱いとさせていただきます。キャンセルされた場合は、キャンセル料が発生し、商品を受け取ることが出来ませんのでご了承ください。`,
        message5: `受け取り予約している時間以外に受け取ることは出来ますか？`,
        message6: `受取予約時間以外に受け取る事はできません。`,
        message7: `出国日以外の日程に受け取れますか？`,
        message8: `日本滞在中であればいつでも受け取れますのでご安心ください。ただしお客様が選択した受け取り日時は必ず守っていただくようお願いいたします。`,
        message9: `ロッカーの受け取り場所はどこにある？税関前にある？出国エリアにある？`,
        title: `よくあるご質問`
      },
      locker: {
        step1: {
          description: (className: string) =>
            `日本全国の<span class=${className}>空港・駅・バスターミナル</span>などに設置されている無人ロッカーにて簡単に商品が受け取る`,
          title: `受け取り場所を決める`
        },
        step2: {
          description: (className: string) =>
            `ロッカー前で、<span class=${className}>予約詳細ページ</span>から予約情報の<span class=${className}>「決済手続き」</span>にロッカーのタブレットに表示されている<span class=${className}>4桁の数字</span>を入力してください。`,
          title: `QRコードの確認`
        },
        step3: {
          description1: (className: string) =>
            `※<span class=${className}>ICチープ付きのパスポートが必要</span>になります。\n`,
          description2: `※受取る時に、ICチープ付きのパスポートでの 本人確認が必要のため、必ず持ってきてください。`,
          title: `パスポートの確認`
        },
        step4: {
          description: `ロッカー前で、購入履歴ページにある「決済用4桁数字コードを入力する」ボタンを押して、ロッカーのタブレットに表示される4桁の数字を入力してください`,
          title: `受取り時の決済`
        },
        step5: {
          description: (className: string) =>
            `ロッカータブレットの手順に従い、<span class=${className}>商品を受け取ってください</span>`,
          title: `商品の受取り`
        }
      },
      pickup: {
        title: `受取り場所`
      },
      table: {
        title: `ロッカーと対面の違い`,
        row1: {
          column1: `不在`,
          column2: `スタッフが対応`,
          header: `スタッフの有無`
        },
        row2: {
          column1: `・予約時：20%\n・受取時：80%`,
          column2: `・予約時：100%\n・受取時：ー`,
          header: `支払い方法`
        },
        row3: {
          column1: `必要`,
          column2: `不要`,
          header: `VJWの登録`
        },
        row4: {
          column1: `・ICチップ付きパスポート\n・上陸許可証`,
          column2: `・VJWの免税QRコード`,
          header: `受け取りに必要なもの`
        },
        row5: {
          column1: `未対応`,
          header: `JTTP`
        }
      }
    }
  },
  coupons: {
    acquired: `ゲット完了`,
    allYouCanUse: (highlight: string) => `誰でも使える<span class=${highlight}>クーポン</span>`,
    allYouCanUseText: `誰でも使えるクーポン`,
    canBeUsedForJcb: `※選択中のクーポンはJCBカードのみ利用できます。カードを変更するか、クーポンを削除・変更してください。`,
    canBeUsedForWamazingProducts: `※クーポンはWAmazing商品のみに利用できます。`,
    consumableLimitReached: `発行終了`,
    coupon: `クーポン`,
    couponForEveryone: `誰でも使える`,
    discountByAmount: (amount: number) => `割引 ${amount} 円`,
    discountByRate: (rate: number) => `割引 ${formatDigits(100 * rate)}%`,
    discountLimit: (discountLimit: number) => `最大 JPY${discountLimit} 割引`,
    minSettlementAmountRemark: (minSettleMent: number) =>
      `割引前に、${commaedInteger(
        minSettleMent
      )} 円以上のオーダーでご利用いただけます。※お支払い金額が5,000円未満の場合は免税要件を満たさないため購入できません。`,
    noCouponToUse: `ご利用いただけるクーポンがありません`,
    noMedsAlcohol: `医薬品、お酒類は本割引の対象外です。`,
    notLogin: `ログインしてから、クーポンを登録できます`,
    notUseCoupon: `クーポンが利用しません`,
    note: `注意事項`,
    pickCoupon: `クーポンを選ぶ`,
    pleaseReview: `このクーポンを使用できません。クーポンの利用条件をご確認ください。`,
    terms: `使用条件`,
    usableBeforeJst: `(日本時間) までに有効`,
    usePromoCode: `クーポンコードを入力します`,
    discount: {
      limit: (amount: number) => `本クーポンの割引額は最大${amount}円です。`
    },
    list: {
      pleaseLogin: `クーポンをゲットするために、先にログインしてください。`,
      title: `クーポン一覧`,
      page: {
        description: `日本全国のご当地おみやげ、日本旅行のお土産をもっと楽に、お得に買うなら、WAmazingオンライン免税店！`,
        title: `WAmaizing shopのクーポン｜ワメイジング`
      }
    }
  },
  creditCard: {
    error: {
      identityAuthentication: `クレジットカードの決済認証が失敗しました。`,
      useAnotherCard: `他のクレジットカードをご利用ください。`
    }
  },
  crossSelling: {
    activity: {
      title: `東京で人気の体験アクティビティの行程`
    },
    tickets: {
      title: `東京へのモビリティ & お得な交通チケット`
    }
  },
  customerSupport: {
    chat: `チャットで相談`,
    description: `よくある質問。日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`,
    title: `カスタマーサポート\n`
  },
  discountNotice: {
    addToCart: (rate: number) => `${rate}％割引が適用されカートに追加されました`,
    description: `カート追加で自動で適用されます。\n他クーポンとの併用も可能です。`,
    mainText: (className: string, rate: number) =>
      `こちらの商品は、<span class=${className}>${rate}％割引対象商品</span>です`
  },
  favorites: {
    addSelectedToCart: `選択中の商品をカートに追加`,
    addToFavorite: `お気に入りに追加する`,
    addedToFavorite: `お気に入りに追加しました。`,
    isEmpty: `お気に入り商品がありません`,
    notLogin: `お気に入り機能を使うには\nログインしてください。`,
    removeSelectedFromFav: `選択中の商品をお気に入りから削除`,
    title: `お気に入り`
  },
  featured: {
    featuredCollections: `特集一覧`,
    keywords: `注目キーワード`,
    moreFeaturedCollections: `特集一覧をもっと見る`,
    popularCosmeticSets: `WAmazing Exclusive Popular Cosmetic Sets`,
    recommendedFeaturedCollections: `おすすめ特集`,
    recommendedProducts: (largeCategoryName: string) => `おすすめの${largeCategoryName}\n`,
    shiseidoBestHit2023: `SHISEIDO Best Hit Cosme 2023`,
    antiUVCosmeticsLP: {
      description: `「あの人気コスメはどこで買える？」最新の紫外線対策グッズが免税価格で予約購入が可能です。「ANESSA」　「クレドポーボーテ」「POLA」「SK2」など、大人気化粧ブランドが勢揃い。バイヤーがリアルにおすすめしたいコスメをご紹介します。`,
      title: `日本で買うべき、紫外線対策用コスメ特集`,
      addToCartNow: {
        title: `今すぐカートに追加`
      },
      buyerComment: {
        title: `バイヤーズコメント`
      },
      buyerRecommendation: {
        comment: `これからの季節には、紫外線や乾燥などの外的ストレスから守り、輝きを引き出すCPBのスキンケアセットがおすすめ。\n世界トップレベルの技術を集結させたCPBは、使用者の絶賛の声が止まらない、大人気ブランドです。`,
        title: `WAmazingバイヤーおすすめ！\n夏のスキンケアセット`,
        product: {
          content: `クレ・ド・ポー ボーテ ローションイドロ 170ml\nクレ・ド・ポー ボーテ エマルションプロテクトゥリス 125ml\nクレ・ド・ポー ボーテ ル・セラム 50ml`,
          title: `Cle de Peau Beaute（クレ・ド・ポー ボーテ） 【5％OFF】Cle de Peau Beaute　おすすめ夏対策セット`
        }
      },
      contentDesc: {
        setTitle: `セット内容`,
        title: `特徴`
      },
      featuredCosmeticPrimer: {
        comment: `UVカットからベースメイクまで、シンプルな1ステップで自然体の美しい肌が完成`,
        title: `2024年注目の化粧下地`,
        product: {
          content: `紫外線対策、トーンアップ、色補正するUVティンティドクリーム。\nノンケミカル処方で、国内基準最高レベルのUVカット力`,
          title: `THREE スムースオペレーターハイパフォーマンスクリーム 01`
        }
      },
      featuredSunscreen: {
        comment: `絶対に日焼けしたくない方にゴールドのANESSA！\nミルクタイプなのにぬるとさらさらと肌になじむテクスチャーで伸びが良く、\n日焼け止め特有の重たさを感じません。\n下地としても使えるのでデイリー使いにおすすめです。\nちろんウォータープルーフなのでスポーツやレジャーにも最適！石鹸で落とせるのも嬉しいポイント。`,
        title: `紫外線対策の基本！\n2024年注目の日焼け止め　`,
        product: {
          content: `長時間保湿\nウォータープルーフ\n石鹸で落ちる\nフローラルの香り`,
          title: `ANESSA`
        }
      },
      recommendationRate: {
        title: `おすすめ度`
      },
      sale: {
        setTitle: `特別セット価格`,
        title: `特別価格`
      },
      saleText: {
        title: (currency: string, preDiscountPrice: number, discountAmount: number, className: string) =>
          `通常${currency}<span class=${className}>${preDiscountPrice}</span>(税込)が今なら${currency}<span class=${className}>${discountAmount}</span>お得`
      }
    },
    anti_aging: {
      short_desc: `アンチエイジングやしわ対策に使える、日本のおすすめスキンケア・化粧品`,
      title: `アンチエイジング・しわ対策特集`
    },
    beautyAppliances: {
      subTitle: `自分へのご褒美にもぴったりな、日本製の美容家電や美容グッズを集めました。`,
      title: `最先端、美容家電＆グッズ`
    },
    buyersChoiceFood: {
      subTitle: `日本中を知り尽くしたWAmazingのバイヤーがおススメする商品を集めました。`,
      title: `バイヤーズチョイス（食品）`
    },
    coldSake: {
      subTitle: `暑い季節に飲みたい、冷やしておいしい日本酒を集めました。`,
      title: `おすすめ冷酒`
    },
    collagen: {
      short_desc: `美容の人気成分であるコラーゲンが配合された、日本ブランドのスキンケア商品、化粧品、サプリメント`,
      title: `コラーゲン特集`
    },
    drug: {
      adBanner: {
        title: `Must buy in Japan Drugs`
      }
    },
    drug_store: {
      short_desc: `日本のドラッグストアの必買コスメやお菓子`,
      title: `日本ドラッグストア化粧品・お菓子特集`
    },
    facialCleansers: {
      subTitle: `洗顔するたびきれいになれる。そんなおすすめの洗顔料を選びました。`,
      title: `日本で人気の洗顔料`
    },
    gift: {
      subTitle: `日本ならではのギフトを取りそろえました。`,
      title: `贈り物に最適、日本のギフト特集`
    },
    index: {
      meta: {
        description: `お買い得の商品や季節ごとのおすすめ商品の特集一覧。日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`
      }
    },
    japaneseTraditionalSweetAndSnacks: {
      subTitle: `日本中から様々な人気の和菓子を集めました。`,
      title: `日本の伝統、和菓子`
    },
    limitedSale: {
      caveat: `只今、期間限定の割引商品を準備中のため、しばらくお待ちください。`,
      expirationConfirm: `■購入する前に、商品説明をご確認してください`,
      expirationDate: (year: string, month: string, day: string, className: string) =>
        `この商品は受取日限定販売になっています。\n<span class=${className}>「${year}/${month}/${day}」以降の販売は行っていません</span>ので、受取日を上記の日程の前にする必要があります。`,
      title: `期間限定セール`
    },
    lotion: {
      bestLotionsToBuyInJapan: `日本で買いたい化粧水`,
      description: `編集部からのおすすめ化粧水  |  絶対買う日本人気商品、日本旅行のお土産をもっと楽に、お得に買うなら、WAmazingオンライン免税店！`,
      leadSentence: `久々の日本旅行、そして円安！ショッピングするならまさに今！ですよね。\n今回は、完美行編集スタッフがおすすめする「プレゼントに喜ばれるコスメ ～化粧水編～」をご紹介します。今回は一番ベーシックな化粧水で編集者各自のおすすめをご紹介。友達や家族などにプレゼントを考えてる方はもちろん、自分へのご褒美としても是非参考にしてみてくださいね！\n日本でしか購入できない商品もあるので要チェックです！\n※以下は個人の感想です\n`,
      otherLotions: `その他の化粧水はこちら`,
      wamazingEditorChoice: `WAmazing編集部おすすめ`,
      elixir: {
        description: `こちらも海外ではまだ未発売の商品なので、是非おすすめしたい商品です！パッケージも、以前よりシンプルになって、20代～40代まで幅広い人に喜ばれると思います。この中では一番とろみがある化粧水で、フローラルの香りも癒されます。`,
        title: (className: string) =>
          `2022年9月にリニューアル！<span class=${className}>「エリクシール シュペリエル リフトモイスト」</span>`
      },
      haku: {
        description: `美白を目指してる方に是非おすすめしたいのがこちらです。美白有効成分が入っていてとろっとした質感です。保湿もされながらさらさらした使い心地が良いです。香りがほのかなところもお気に入りです。`,
        title: (className: string) => `美白化粧水といったら\n<span class=${className}>「HAKU」</span>`
      },
      obagi: {
        description: `少し年齢の高いご家族へのお土産におすすめしたいのがこちらです。日本でもエイジングケアで口コミが多いです。保湿力が高く、とろみのある化粧水が浸透していく感じがします。柑橘系の香りがすっきりした気分にしてくれます。高価格アイテムなので、円安の今が特にお得です！`,
        title: (className: string) => `保湿力の高い\n<span class=${className}>「Obagi X」</span>`
      },
      orbis: {
        description: `オルビスでも大人気の「ORBIS U」が 日本でリニューアルされました。これは海外では販売されてないので友達に喜ばれること間違いなしだと思います。\nとろみのある化粧水でしっとりします。リニューアルボトルは蓋に三角の切り込みが入っているのもスタイリッシュでポイントです。`,
        title: (className: string) =>
          `日本でしか買えない！\nリニューアルされた<span class=${className}>「ORBIS U」</span>`
      }
    },
    meta: {
      common: {
        description: `日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`
      }
    },
    mtFuji: {
      subTitle: `日本土産といったらコレ！かわいい富士山グッズを集めました。`,
      title: `富士山グッズ特集`
    },
    nibbles: {
      subTitle: `日本のおつまみをセレクトしました`,
      title: `お酒が進む！日本のおつまみ`
    },
    pickUp: {
      title: `PICK UP商品`
    },
    quickShip: {
      shopNow: `みてみよう`,
      title: `最速送達商品`
    },
    sensitive_skin: {
      short_desc: `敏感肌の方でも安心して使える、日本のおすすめスキンケアや化粧品`,
      title: `敏感肌向けのスキンケア特集`
    },
    serums: {
      subTitle: `日本製のメーカーから発売している高品質な美容液をそろえました`,
      title: `日本の高品質、美容液`
    },
    shoppingArticle: {
      title: `ショッピングに役立つ情報`
    },
    skin_whiten: {
      short_desc: `日本ブランドのおすすめ美白スキンケア製品`,
      title: `美白・しみ対策特集`
    },
    slug: {
      meta: {
        description: `日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`
      }
    },
    summer2023: {
      naviTitle: `2023年夏のおすすめ商品`
    },
    summerTreats: {
      subTitle: `暑い日のご褒美に！冷やしておいしい夏スイーツを集めました。`,
      title: `冷やして美味しい、夏スイーツ`
    },
    sunBlockRecommendation: {
      subTitle: `紫外線対策、完璧ですか？絶対焼かない！今から始めるUVケア`,
      title: `2024年UVケア特集`
    }
  },
  featuredCollections: {
    allShow: `特集をすべて見る`
  },
  footer: {
    genuineDescription: `全ての商品は本物でございます`,
    genuineTitle: `本物保証`,
    safeDescription: `安心安全で利用できるサービス`,
    safeTitle: `安心・安全`,
    serviceGuide: `サービスガイド`,
    userAgreement: `利用規約`,
    weappDescription1: `スキャンしてフォローできる`,
    weappDescription2: `WAmazingで日本を楽しもう`,
    weappTitle: `公式アカウント`
  },
  guide: {
    attention1: `空港を\n間違わないこと`,
    attention2: `スケジュールを\n間違わないこと`,
    attention3: `パスポートを\n忘れないこと`,
    attention4: `ネット環境を\nご用意すること`,
    confirmIdentity: (className: string) =>
      `ロッカーのタブレットの手順に従い、<span class=${className}>本人確認</span>を行ってください。`,
    confirmLocation: `受取り場所の確認`,
    confirmPassport: `パスポートの確認`,
    confirmQrcode: `QRコードの確認`,
    description: `ワメイジングの利用方法。日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`,
    dontForget: `注意してほしいこと`,
    enterFourDigitNumber: (className: string) =>
      `ロッカー前で、<span class=${className}>予約詳細ページ</span>から予約情報の<span class=${className}>「決済手続き」</span>にロッカーのタブレットに表示されている<span class=${className}>4桁の数字</span>を入力してください。`,
    followTabletAndReceive: (className: string) =>
      `ロッカーのタブレットの手順に従い、<span class=${className}>商品を受け取ってください</span>。`,
    mustBeEPassport: (className: string) =>
      `※<span class=${className}>ICチープ付きのパスポートが必要</span>になります。`,
    note: `※受取る時に、ICチープ付きのパスポートでの 本人確認が必要のため、必ず持ってきてください。`,
    openQrcodeAndScanTablet: (className: string) =>
      `ロッカー前で、<span class=${className}>予約詳細ページ</span>を開き、予約情報の<span class=${className}>「商品受け取り用QRコード」</span>からQRコードを出して、ロッカータブレットにスキャンしてください。`,
    payment: `受取り時の決済`,
    receive: `商品の受取り`,
    title: `受取り方法`,
    notes: {
      comeInPerson: `商品のご購入、及びお受け取り時の混雑緩和の為、購入予約者ご本人様のみでお越しの上、お手続きを実施頂けますようお願い致します。`,
      note1: `決済の実施において、通信環境が必要となります。お客様にて通信環境をご用意頂けますようお願い致します。`,
      note2: `購入予約者ご本人様のみがお手続きを実施頂けます。必ず購入予約者ご本人様がお越しください。`,
      note3: `購入予約時にご指定頂いた場所、及び受取希望日時でのみお手続きを実施頂けます。必ず場所、日時をご確認の上お越しください。`,
      note4: `お手続きには購入予約者ご本人様のパスポート、及び当該パスポートに貼付された上陸許可証印シールが必要となります。必ずご持参ください。なお、パスポートはIC対応の物に限ります。また、上陸許可証印シールは有効期限内の現物に限ります。`,
      note5: `お手続きにおいて、購入予約者ご本人様の顔を撮影させて頂きます。予めご了承ください。なお、撮影させて頂いた画像は、持参頂いたパスポートとご本人様の一致を確認する目的のみに使用し、確認後、速やかに削除致します。`,
      note6: `お手続きにおいて、購入予約者ご本人様のアカウントで当社サービスにログインの上、決済を実施頂きます。購入予約者ご本人様と異なるアカウントでの決済は実施頂けません。予めご了承ください。`,
      note7: `何れか１つでもお守り頂けない場合、お手続きを実施頂く事は出来ません。予めご了承ください。`,
      other: `その他`,
      readFollowingNotes: `商品のご購入、及びお受け取りのお手続きについて、予め以下ご確認頂けますようお願い致します。`,
      title: `注意事項`
    },
    page: {
      title: `使い方ガイド`
    }
  },
  index: {
    BeautyEquipmentsRecommendation: {
      subTitle: `日本人氣美容、瘦身健康食品`,
      title: `美容仪器`
    },
    babyProductsRecommendation: {
      subTitle: `粉ミルク、離乳食などのベビー用品を集めました`,
      title: `日本の人気ベビー用品`
    },
    dhcRecommendation: {
      subTitle: `ビタミンやコラーゲンなど人気のDHCサプリメント`,
      title: `DHCサプリメント`
    },
    healthFoodRecommendation: {
      subTitle: `人気の美容・ダイエットの健康食品`,
      title: `健康食品`
    },
    maskRecommendation: {
      subTitle: `厳選した人気マスで大切なお肌をケアし、毎日いい気分`,
      title: `マスク`
    },
    matchaRecommendation: {
      subTitle: `日本といえば抹茶！\n人気の抹茶商品を集めました`,
      title: `人気の抹茶みやげ`
    },
    omiyageRecommendation: {
      subTitle: `人気お土産お菓子、プレゼントに最適`,
      title: `厳選日本お土産お菓子`
    },
    popularRecommendation: {
      subTitle: `厳選した口コミのいい商品、絶対買いたいリスト`,
      title: `絶対買いたい商品`
    },
    shiseidoBestHit2023: {
      subTitle: `殿堂入りコスメたちを是非お試しください。`,
      title: `SHISEIDO Best Hit Cosme 2023`
    },
    snacksRecommendation: {
      subTitle: `厳選した日本限定の美味しいお菓子、プレゼントに最適`,
      title: `人気お菓子`
    },
    snacksSetRecommendation: {
      subTitle: `空港で買えない限定の人気お菓子セット、プレゼントに最適`,
      title: `人気お菓子のセット`
    },
    summer2023Recommendation: {
      subtitle: `2023夏の家族旅行のおすすめ商品特集`
    }
  },
  issuedCoupon: {
    checkCouponNow: `今すぐクーポンを確認`,
    couponHasBeenIssued: (className: string) =>
      `クーポンを獲得しました。\nクーポンは<span class=${className}>カート画面の「クーポンを選ぶ」</span>からご確認できます。`
  },
  localSouvenirs: {
    area: {
      suffix: `エリア`,
      title: (area: string) => `${area}のおみやげ`
    },
    aside: {
      left: {
        title: `Contents`
      }
    },
    buyerComment: {
      title: {
        full: `今月のバイヤーズチョイス`,
        row1: `今月の`,
        row2: `バイヤーズチョイス`
      }
    },
    buyerPickUpsByRegion: {
      title: {
        full: `日本全国バイヤーのおすすめをピックアップ`,
        row1: `日本全国バイヤーのおすすめを`,
        row2: `ピックアップ`
      }
    },
    buyerRecommendedMaker: {
      title: {
        full: `今月のピックアップメーカー`,
        row1: `今月の`,
        row2: `ピックアップメーカー`
      }
    },
    hokkaidoTohoku: {
      description: `北海道・東北エリアは広大な自然と寒冷な気候が生み出す美味がたくさん！北海道は農業や酪農が盛んなため、ジャガイモや乳製品を使ったおみやげが有名。山形や岩手・宮城などの東北エリアは地域色あふれるソウルフードや県毎に特徴が異なる日本酒も魅力。`,
      title: `北海道・東北`
    },
    japan: {
      description1: `日本全国のご当地おみやげが大集合！`,
      description2: `オンライン免税店「WAmazing買い物」なら事前に注文ができて空港や駅で受け取れるから、日本全国のおみやげが購入できる！\n気になる地域のおみやげをチェックしてみよう♩`,
      navi: `日本全国おみやげ大集合`,
      title: `日本全国　おみやげ大集合`
    },
    kansaiChushikoku: {
      description: `関西・中四国エリアは大阪・京都・奈良や、瀬戸内海を囲む広島や四国（香川・愛媛・徳島・高知）がある地域。瀬戸内海近郊は気候がよく海産物も豊富なため海鮮を利用したおみやげや、名産品であるレモンを利用したおみやげが有名！`,
      title: `関西・中四国`
    },
    kantoKoshinetsu: {
      description: `東京や神奈川など観光名所が多いため、来訪者も多い関東甲信越エリア。味はもちろん、パッケージもおしゃれで人にあげたくなるおみやげがずらり！日本屈指の米どころ・新潟は日本人にもファンが多い地酒も多数。`,
      title: `関東甲信越`
    },
    kyushuOkinawa: {
      description: `九州・沖縄エリアは、福岡・熊本・鹿児島や沖縄がある地域。九州は、特産である明太子を使ったお菓子や蒸留酒「焼酎」が豊富。沖縄は地産の黒糖や塩を使ったお菓子や「ちんすこう」など、沖縄ならではのおみやげが揃っています。`,
      title: `九州・沖縄`
    },
    maker: {
      aokiSofuan: {
        description: `大阪の青木松風庵は1983年創業の老舗和菓子店です。その名物土産「月化粧」は特に人気が高く、今や大阪土産の定番です。厳選された地元産素材を使用し、伝統技術と革新を融合させた商品が特色で幅広い世代に愛されています。店舗は洗練されたデザインで、一部にはカフェスペースも併設。名物「月化粧」は主に関西エリアで購入可能です。地域貢献にも積極的で、地元行事への参加や地域素材を使った商品開発も行っています。`,
        title: `青木松風庵`
      },
      obusedo: {
        description: `小布施堂は、長野県小布施町にある老舗の和菓子店で、栗の産地として知られるこの地域の高品質な栗を使った和菓子が大変魅力です。栗鹿ノ子や栗蒸し羊羹などが特に人気で、美しい町並みを楽しみながら季節限定や限定店舗の商品を堪能できます。併設のカフェやレストランでは、地元食材を取り入れたデザートや料理を提供。創業約400年の歴史と文化を感じる事ができ、更に心温まるおもてなしを受ける事が出来ます。`,
        title: `小布施堂`
      }
    },
    page: {
      description: `「大人気の定番土産」から「通常現地でしか手に入らない地域限定商品」まで、500種以上の全国各地の地方土産が揃う免税オンラインショップです。事前に予約購入して、駅や空港で受け取りが可能！売り切れの心配も行列に並ぶ必要もありません。日本全国各地を巡ったWAバイヤーが厳選した「月替わりのおすすめ商品」から「人気ランキング」まで、最新の日本土産を旅する気分でお楽しみください。`,
      title: `47都道府県制覇！日本で買うべき、WAバイヤーがお勧めする全国土産が大集合！`
    },
    prefecture: {
      aichi: `愛知県`,
      akita: `秋田県`,
      aomori: `青森県`,
      chiba: `千葉県`,
      ehime: `愛媛県`,
      fukui: `福井県`,
      fukuoka: `福岡県`,
      fukushima: `福島県`,
      gifu: `岐阜県`,
      gunma: `群馬県`,
      hiroshima: `広島県`,
      hokkaido: `北海道`,
      hyogo: `兵庫県`,
      ibaraki: `茨城県`,
      ishikawa: `石川県`,
      iwate: `岩手県`,
      kagawa: `香川県`,
      kagoshima: `鹿児島県`,
      kanagawa: `神奈川県`,
      kochi: `高知県`,
      kumamoto: `熊本県`,
      kyoto: `京都府`,
      mie: `三重県`,
      miyagi: `宮城県`,
      miyazaki: `宮崎県`,
      nagano: `長野県`,
      nagasaki: `長崎県`,
      nara: `奈良県`,
      niigata: `新潟県`,
      oita: `大分県`,
      okayama: `岡山県`,
      okinawa: `沖縄県`,
      osaka: `大阪府`,
      saga: `佐賀県`,
      saitama: `埼玉県`,
      shiga: `滋賀県`,
      shimane: `島根県`,
      shizuoka: `静岡県`,
      tochigi: `栃木県`,
      tokushima: `徳島県`,
      tokyo: `東京都`,
      tottori: `鳥取県`,
      toyama: `富山県`,
      wakayama: `和歌山県`,
      yamagata: `山形県`,
      yamaguchi: `山口県`,
      yamanashi: `山梨県`
    },
    region: {
      chugoku: `中国`,
      hokkaido: `北海道`,
      hokuriku: `北陸`,
      kansai: `関西`,
      kanto: `関東`,
      kyushu: `九州`,
      okinawa: `沖縄`,
      shikoku: `四国`,
      tohoku: `東北`,
      tokai: `東海`,
      airport: {
        chugoku: `広島空港`,
        hokkaido: `新千歳空港`,
        hokuriku: `null`,
        kansai: `JR関西空港駅`,
        kanto: `JR成田空港駅\nJR成田第2ビル駅\n羽田空港T3駅`,
        kyushu: `天神BT\nJR博多駅`,
        okinawa: `那覇空港`,
        shikoku: `null`,
        tohoku: `仙台空港`,
        tokai: `セントレア空港`
      },
      description: {
        chugoku: `中国地方は、温暖な気候が育む多彩な食材と名物料理が魅力です。広島のお好み焼きや尾道ラーメン、岡山の白桃やマスカットが絶品です。また、島根の出雲そばや山口のふぐ刺しも地域を代表する美味しさ。さらに、広島のもみじ饅頭や、岡山のきびだんごなど、お土産スイーツも充実。新鮮な海の幸と肥沃な土地から生まれる食文化は、訪れる人々を魅了します。`,
        hokkaido: `北海道は雄大な自然と、その自然から生まれる絶品グルメで世界中のツーリストに人気！農畜産物、乳製品、海産物、酒類は新鮮で質が高く、古くから日本では「食の宝庫」として知られています。特に野菜や果物、濃厚な乳製品、新鮮な魚介類は絶賛され、日本酒やビールも地元の風味として愛されています。`,
        hokuriku: `北陸地方は、新鮮な海の幸が豊富で、特に富山のホタルイカや福井の越前ガニ、石川ののどぐろなど、高級海産物で有名で、北陸エリアならではの特産物としてし昔から親しまれています。また、水もきれいなので日本酒でも有名です。酒造りの歴史は深く、こだわりの製法で作られた日本酒は、まろやかな口当たりと豊かな香りが特徴です。さらに、北陸地方は多様な和菓子が揃うことで知られており、金沢の金箔を使った豪華な和菓子や、福井の羽二重餅が人気です。`,
        kansai: `関西は、豊かな「歴史」と深い文化が息づく地域で、料理もその影響を強く受けています。特に「抹茶」は、京都を中心に発展し、茶道文化と共に美味しいスイーツが多く誕生しました。抹茶を使った和菓子や、洋風のスイーツまで、そのバリエーションは豊かで、古都の風情を感じながら楽しむことができます。この融合が関西の食の大きな魅力です。\nまた、京都の伏見や兵庫の灘では、清らかな水と良質な米を用いて、古くから高品質な日本酒が醸造されており、名高い日本酒の産地として知られています。`,
        kanto: `関東地方では、江戸前寿司、天ぷら、そばなどの江戸前料理が堪能できます。また、東京には築地市場や豊洲市場といった大規模な魚市場があり、全国から新鮮な魚が集まるため、新鮮な海の幸も楽しむことが出来ます。多様性街、東京では最新のスイーツやお土産も多くありますが、銀座や浅草といったエリアには和菓子の老舗店も多く、伝統的な味を楽しむことができます。`,
        kyushu: `九州は美食の宝庫で、さまざまな名物料理が楽しめます。福岡の博多ラーメン、大分の鶏天、鹿児島の黒豚は人気です。果物やスイーツも豊富で、福岡の「あまおう苺」や長崎の「カステラ」は全国的にもとても有名。また、九州のお酒といえば焼酎と言われるほど、焼酎の名産であり古くから親しまれています。`,
        okinawa: `沖縄は豊かな自然と独特の文化が楽しめる食文化があります。ゴーヤーチャンプルーやジーマミ豆腐、ソーキそばなど、地元食材を活かした料理は絶品。お土産には島とうがらしを使ったお菓子や、紅芋タルトやちんすこうが大人気です！また、沖縄といえば泡盛というほど個性的なお酒の産地でもあります。`,
        shikoku: `四国は豊かな自然と温暖な気候を活かした食材が特徴的です。高知のカツオのたたきや、愛媛の新鮮な鯛料理、香川の讃岐うどん、徳島の阿波尾鶏など、各地で独自の料理が楽しめます。また、みかんやすだちなどの柑橘類も豊富で、地元ならではの新鮮で風味豊かな味わいが魅力です。それぞれの地域が育む風土と伝統を感じることができる食文化が四国の魅力です。`,
        tohoku: `東北地方は、日本の北東部に位置し、美味しい海産物や米、発酵食品が豊富です。新鮮な牡蠣やホタテ、伝統的な郷土料理（きりたんぽ鍋、わんこそば）などが楽しめます。また、日本酒の名醸地としても知られ、美味しい地酒が揃っています。自然豊かなエリアなので、さくらんぼやリンゴの産地としても有名です。`,
        tokai: `東海地方の食の魅力は多岐にわたります。その魅力は、名古屋の絶品味噌カツや、香ばしいひつまぶし、そして静岡の風情漂うおでんなど、各地の特産品を活かした至極の料理に集約されています。名古屋は、日本中で一際異彩を放つ独特の食文化で知られ、名物の一つである小倉トーストなどのヒット商品を次々と生み出しています。この地域を訪れる際には、是非ともその豊かで多彩なグルメを堪能してください。\n\n`
      },
      label: {
        chugoku: `中国・四国`,
        hokkaido: `北海道・東北`,
        hokuriku: `東海・北陸`,
        kansai: `関西`,
        kanto: `関東`,
        kyushu: `九州・沖縄`,
        okinawa: `九州・沖縄`,
        shikoku: `中国・四国`,
        tohoku: `北海道・東北`,
        tokai: `東海・北陸`
      }
    },
    relatedArticles: {
      title: {
        full: `お土産に関わりのあるおすすめ記事`,
        row1: `お土産に関わりのある`,
        row2: `おすすめ記事`
      }
    },
    souvenirRanking: {
      title: {
        full: `日本全国のお土産ランキング`,
        row1: `日本全国の`,
        row2: `お土産ランキング`
      }
    },
    tokaiHokuriku: {
      description: `東海・北陸エリアは、名古屋のある愛知や静岡、日本文化が色濃く残る石川（金沢）や富山・福井がある地域。特に北陸エリアの日本酒は、寒さが厳しく水も豊富という日本酒を作る環境が揃っているため格別！`,
      title: `東海・北陸`
    }
  },
  lp: {
    mediaCoupon: {
      goToTop: `トップへ戻る`,
      goToWAmazing: `WAmazing Shopを見てみる`,
      faq: {
        a1: `申し訳ございません、変更はできません。キャンセルしてから買い直しください。`,
        a2: `医薬品（販売元：スギ薬局）は免税対象外となります。医薬品のみの場合は別途3,000円以上が必要です。`,
        a3: `申し訳ございません、ICチップ付きパスポートをお持ちでない場合は商品のお受取りができません。`,
        a4: `法規制により免税手続きができないので所有者の受取りをお願いします。`,
        label: `よくあるご質問`,
        q1: `受取日を変更できますか？`,
        q2: `医薬品も免税範囲に含まれますか？`,
        q3: `ICチップ付パスポートを持っていませんが、商品を受け取ることはできますか？`,
        q4: `パスポート所有者でなくても商品を受取れますか？`,
        q5: `支払い方法は何がありますか？`,
        a5: {
          aftee: `AFTEE pay now`,
          detail1: `支払いはオンラインクレジットカードを利用できます。VISA、Mastercard、JCB、American Express カードを利用できます。`,
          detail2: `wechatpay を使用する方は、商品の受取りや残高の支払いの際にも wechatpayを使用する必要があります`,
          detail3: `スーパーマーケットの支払い、ATM、電子財布（AFTEE pay now）も利用できます。`
        }
      },
      footer: {
        app: `ここからアプリをダウンロード`,
        enjoy: `日本の楽しみを満喫する素晴らしい人生`,
        wamazing: `WAmazing`
      },
      hero: {
        subtext1: `人気の日本土産`,
        subtext2: `オンライン`,
        subtext3: `空港でお土産`,
        subtitle: `免税カウンターにもう並ばない！`,
        text1: `多数`,
        text2: `予約`,
        text3: `受取り`,
        title: `旅行と買い物を\nもっと楽しむ\nオンラインショップ`
      },
      how: {
        goToTop: `クーポンを使って買い物をしてみる`,
        label: `お得なクーポンの使い方`,
        labelWithPrice: (price: string) => `${price}円クーポンの使用方法`,
        labelWithRate: (rate: number) => `${formatDigits(100 * rate)}%クーポンの使用方法`,
        list1: `発行ページでクーポンを取得する`,
        list1Click: `以下をクリックしてクーポンを受け取る`,
        list2: `商品をカートに入れます`,
        list3: `⁨⁩カートを確認`,
        list4: `カート画面の「詳細金額」の\n「優待券を選択」をタップ`,
        list5: `１でコピーしたコードを入力して「OK」をタップ`,
        list6: `クーポンが表示されるので\nチェックを入れ「選択」をタップ`,
        list7: `クーポンが適応されました！`,
        notice1: `※クーポンをご利用になるには同じ販売元から<strong>「5,000円以上」購入した場合、適応可能</strong>になります。<strong>免税適応</strong>されるためには5,000円以上買い物をする必要がありますので「<strong>販売元</strong>」を目印に買い物をお楽しみください。`
      },
      introduction: {
        feature1: `旅行前に注文`,
        feature2: `空港で受取り`,
        feature3: `セルフ型免税`,
        forWamazing: `WAmazing Shopとは、\n商品を事前に予約注文し、\n日本の空港で\n受取れるサービスです。`,
        introText: `全く新しいオンライン免税ショップのご提案`
      },
      notice: {
        label: `大切なお知らせ`,
        notice1: {
          text1: `一部人気が集中する商品がございます。\n`,
          text2: `欠品した場合、メーカー側の都合で再販売に時間が要してしまうことがございます。\n`,
          text3: `あらかじめご了承ください。`
        },
        notice2: {
          text1: `ご利用を検討されているお客様は`,
          text2: `お早めにご購入ください。`
        }
      },
      problem: {
        list1: `旅行中は荷物の<em>持ち歩きに困った</em>`,
        list2: `子供を見るのに荷物が<em>邪魔で大変</em>`,
        list3: `電車や道で人に<em>ぶつかりそう</em>になった`,
        list4: `コインロッカーは<em>いつも空きなし</em>`,
        list5: `商品の取り扱っている<em>店舗探しで苦労</em>`,
        list6: `お土産選びで帰りの空港で<em>バタバタ...</em>`,
        list7: `時間を考えると買い物を<em>楽しめない</em>`,
        list8: `思ったよりも<em>お土産代が高くなった</em>`,
        more: `もっと観光を楽しみたいのに`,
        note1: `で、あなたのお悩みにお応え\n`,
        note2: `思い出に残る日本旅行をお手伝いします`,
        strong: `こんなお悩みありませんか？`,
        point: {
          subject: `WAmazing Shop`,
          subtext1: `お土産探し時間\n`,
          subtext2: `記念写真を`,
          subtext3: `免税だから\n`,
          text1: `短縮`,
          text2: `\n撮影楽々`,
          text3: `お得買い`
        }
      },
      safety: {
        label: `WAmazing でのショッピングの三大安心`,
        subtitle: `当社の製品は全て正規品を取り扱っています。`,
        title: `正規品について`,
        list1: {
          text: `スギ薬局様から医薬品販売に関する指導を受けて販売をしています。`,
          title: `医療品について`
        },
        list2: {
          text: `お客様のプライバシーと、セキュリティの保護に努めています。`,
          title: `個人情報の取り扱い`
        }
      },
      showProducts: {
        add: `人気商品続々追加中！`,
        find1: `\nオンラインだから買いたい商品を`,
        find2: `欲しい商品を見つけやすい`,
        label: `商品探しの時間と手間を短縮`,
        title1: `取り扱い商品<em>１万点突破！</em>`,
        title2: `日本全国の商品をお取り寄せ`
      },
      unique: {
        label: `空港の買い物との違い`,
        list1: {
          text: `利用者の多い、免税カウンターに時間をかけて並ぶ必要はもうありません。`,
          title: `免税カウンターに並ばない`,
          type: `並ぶ\n必要なし`
        },
        list2: {
          text: `<em>免税手数料</em>加わって販売されているケースがあります。`,
          title: `手数料が含まれていない`,
          type: `手数料`
        },
        list3: {
          text: `日本に特化した商品を多く取り扱っております。`,
          title: `豊富な品揃え`,
          type: `日本特化`
        },
        list4: {
          text: `化粧品・お菓子・医薬品・アニメグッズなど多くのジャンルを扱ってます。`,
          title: `取扱い商品の幅が広い`,
          type: `アニメ\nグッズも`
        }
      },
      userGuide: {
        label: `シャッターチャンス逃さない`,
        subtitle: `「手ぶら旅行」`,
        title: `お土産荷物を持ち歩かない\n`,
        guide: {
          icon1: `バスターミナル`,
          map1: `受取れる場所は<em>全国11カ所！</em>\n主要都市の空港や駅などにロッカーを配置`,
          multi: `多言語対応で安心`,
          step1: `旅行<em>3ヶ月前</em>から、受取りの<em>3日前まで</em>注文OK！\n\n注文の際、受取りに利用する空港を指定。`,
          step2: `<em>パスポート</em>、<em>入国許可証</em>を使ってお土産を受取り。`,
          step3: `お土産を持って帰国。\nまたは、観光を楽しむ。`,
          support: `"ロッカーで困ったら<em>QRコードから</em>\n\nカスタマーサポートへ"`,
          text: `WAmazing Shopご利用ガイド`,
          threeMins: `受取り時間 約3分`,
          title: `注文から受取り簡単３STEP`
        }
      },
      voice: {
        label: `お客様からの声`,
        list1: `こちらのECサイトでは違うブランド・店舗のお菓子をまとめて買えるので、免税制限をクリアし易かったです。また買い物の選択肢が広かったです。`,
        list2: `日本に着いたら買い物の時間がなかなかないので、先にWAmazing Shopで購入した。非常に便利だと感じた。`,
        list3: `「たくさん荷物を持つ必要がない」という文章を見て、\n便利だと思いました。`,
        list4: `カスタマーサービスの対応と問題解決の姿勢に大変感謝しております。今後も機会があればまたWAmazingの関連サービスを利用していきたいと思います。`
      }
    },
    serviceIntroduction: {
      returnToSnow: `WAmazing Snowに戻る`,
      snowHero: {
        title: `スキー旅行を\nもっと楽しむための\n免税オンラインショップ`
      },
      snowProblem: {
        list1: `スキー用品の<em>持ち歩きに困った</em>`,
        list2: `頼まれたお土産を取り扱っている<em>店舗探しで苦労</em>`,
        list3: `免税手続きや会計が<em>並んでいた</em>`,
        more: `もっとスキー・スノーボードを楽しみたいのに`,
        note: `思い出に残るスキー旅行`,
        strong: `こんなお悩みはありませんか？`
      }
    }
  },
  lunarNewYearSale: {
    drugDiscount: (className: string) => `全品<span class=${className}>20</span>%OFF`,
    metaDescription: `【免税10%OFF➕最大75％OFF】春節キャンペーン限定のお得な商品が多数！`,
    metaTitle: `WAmazingの春節キャンペーン開催`
  },
  maker: {
    maker: `メーカー`
  },
  mypage: {
    title: `マイページ`
  },
  nativeApp: {
    badge: {
      exclusive: `アプリ限定クーポン配布中`,
      title: (pink: string) => `<span class=${pink}>アプリ限定クーポン配布中</span>\nアプリ評価4.7/3,500件以上`,
      download: {
        count: {
          currentDate: `2024年9月5日時点`,
          text: `累計ダウンロード件数30万回突破`
        }
      },
      rating: {
        title: `アプリ評価4.7/3,557件`
      }
    }
  },
  orderForm: {
    addNewCard: `新しいカードを追加`,
    andConfirmedInput: `に同意し、入力が間違いないを確認しました`,
    checkNotes: `注意事項をご確認ください`,
    creditCard: `クレジットカード`,
    creditCardInformation: `支払い方法`,
    dateOfBirth: `護照上的「出生年月日」`,
    dateOfLanding: `入国日`,
    fillDateOfBirthAsPassport: `必ず、パスポートに記載されている「生年月日」をご記入ください。`,
    firstName: `パスポート通りの「名」 (EN)`,
    iAgree: `同意する`,
    lastName: `パスポート通りの「姓」(EN)`,
    nameAndDateOfBirth: `お名前と生年月日`,
    notPurchaseWithoutDateOfBirthAsPassport: `パスポートに「生年月日」が記載されていない場合、免税商品をご購入できませんので、ご了承ください。`,
    orderPlaced: `注文完了`,
    passport: `旅券`,
    passportInformation: `パスポート情報`,
    personalInformation: `個人情報`,
    pickupContent1: `※日本滞在期間内の時間、自由に設定してください`,
    pickupDate: `受取日`,
    pickupIdentity: `個人情報`,
    pickupIdentitySub: `お客様の個人情報は免税サービスのため利用されます`,
    pickupSchedule: `受取スケジュール`,
    pickupTime: `受取時間(日付設定後選択可能)`,
    statusOfResidence: `在留資格`,
    supportedCreditCards: `ご利用いただけるクレジットカード種類`,
    taxFreeProcedures: `免税の手順`,
    userAgreement: `利用・購入規約`,
    validatorMessage: {
      invalidCreditCardType: `VISA, Mastercard, JCB, American Expressのどれかを使用してください`,
      mustBeAlphaNum: (field: string) => `アルファベットまたは数字で${field}を入力してください`,
      mustBeAlphaNumSymbols: (field: string) =>
        `アルファベット、数字、ハイフン、またはアンダースコアで${field}を入力してください`,
      mustBeAlphabets: (field: string) => `アルファベットで${field}を入力してください`,
      mustBeNum: (field: string) => `${field}半角数字で入力してください`,
      mustBeOver20: `日本の法律上、20歳未満の方にお酒の販売は禁じられています`,
      mustNotBeEmpty: (field: string) => `${field}を必ず入力してください`,
      mustSelectCorrectValue: `正しい国籍コードを入力してください`
    }
  },
  orders: {
    actuallyPickedAt: `実際の受取時間`,
    areYouSureToCancelOrder: `本当にオーダーをキャンセルしますか?`,
    autoCancelled: `自動キャンセル`,
    autoCancelledAndCollected: (date: string, className: string) =>
      `受取り締め切り時間<span class=${className}>${date}</span>を過ぎたため、注文をキャンセルさせていただき、荷物も回収させていただきました。`,
    awaitingNextUse: `またのご利用を心よりお待ちしております`,
    canBePickedUpUponArrival: `※入国時にも受取り可能`,
    cancelOrder: `オーダーをキャンセルする`,
    cancellationFee: `キャンセル料`,
    cancellationFeeWillBeChargedAfter: (date: string) =>
      `${date} (日本時間)以降キャンセルする場合、頂いた手数料をキャンセル料として充当させていただきます。`,
    cancelled: `キャンセル済み`,
    cancelledAt: `キャンセル時間`,
    cancelledByCustomer: `お客様のご要望に応じて、\n予約がキャンセルされました`,
    checkReceiveMethod: `受け取り方法を確認`,
    checkReceivePlace: `受け取り場所を確認`,
    checkVjwReg: `VJWの登録方法を確認`,
    confirmPickupMethod: `地図と受け取る方法を確認`,
    createOrder: `オーダーを作る`,
    deadline: `受取り締め切り時間`,
    depositAmount: (field: number) => `預かり金額が${field}円になります。`,
    earliestCollectionDate: `受取り可能な一番早い時間`,
    earliestNotice: `※商品によって、発注処理や出荷時間が異なる。`,
    firstPaid: `予約が完了しました。`,
    goOrderDetailOfSmartPhone: `受取る時に使うQRコードの確認と残額決済のためのコード入力は携帯のサービス画面から行ってください。`,
    infoForPickUp: `受取る時に必要な情報`,
    noCancellationFeeCharged: `現在キャンセル料金は発生しません。`,
    note1: `※1 予約手数料は受け取りまで、免税手続きが完了しないため、 税込商品価格の20％になります。`,
    note2: `※2 予約手数料は最終支払い時に購入金額として充当されます。`,
    note3: `※3 課税商品に関して予約ではなく、決済金額になります。`,
    openLocker1: `ロッカー番号を確認の上、`,
    openLocker2: (className: string) => `<span class=${className}>商品を取り出して</span>ください。`,
    order: `オーダー`,
    orderCancelled: `注文をキャンセルしました。`,
    orderId: `オーダーID`,
    orderPlaced: `注文完了`,
    orderPlacedAt: `オーダー作成時間`,
    orderTitle: `予約詳細`,
    payAtCounter: (amount: number, className: string) =>
      `で支払う総額は<span class=${className}>JPY${commaedInteger(amount)}</span>になります。`,
    payRemainingAmount: `残額は受け取る時にお支払いください。`,
    paymentProcedure: `決済用4桁数字コードを入力する`,
    pickupCompleted: `受け取りが完了しました`,
    pickupLocation: `商品の受け取り場所は`,
    pleasePickUpBeforeDeadline: (date: string) => `日本時間${date}までには受け取ってください。`,
    qrcodeForPickUp: `商品受取り用QRコード`,
    requireInternetEnv: `※受取る時に携帯のネット環境が必要`,
    retrievalProblems: `受け取れなかった場合はこちら`,
    scanQrOnDevice: `こちらのQRコードを受け取り場所で提示してください`,
    secondPaid: `決済が完了しました。`,
    showQrcode: `こちらのQRコードをロッカーのカメラに読み取らせてください。`,
    startReceive: `受け取りを開始する`,
    thankYouForShopping: `ご購入ありがとうございます。`,
    thankYouMessage: `ありがとうございます`,
    vjwRegistered: `はい。VJWの登録しました。`,
    cancelPolicy: {
      Charge20: `合計支払い金額の20%`,
      freeCancellation: `キャンセル無料`,
      note1: `出荷前：キャンセル料が発生しません。`,
      note2: `出荷後：予約手数料100%(商品価格の20%相当（消費税込））`,
      note3: `キャンセルせず、商品を受け取らなかった場合：予約手数料100%(商品価格の20%相当（消費税込））`,
      note4: `お客様都合のキャンセルにより上記のキャンセル手数料が発生する場合、購入予約時にお支払い頂いた予約手数料を充当させて頂きます。`,
      note5: `クーポン利用されており、かつキャンセル料が発生している場合はクーポンをお返しできませんので、ご了承ください。`,
      note6: `キャンセル料が発生し、課税商品が入っている場合、課税商品の合計支払い金額の80%金額を返金させていただきます。`,
      title: `取消费用政策`
    },
    haneda_shop: {
      noteForPickupLocation: (url: string, className: string) =>
        `<a href=${url} target="_blank" rel="noopener noreferrer" class=${className}>中部国際空港の受取場所</a>は、「モノレール改札内」構内にあります。`,
      noteForUsersWithoutJr: (className?: string) =>
        `※モノレールを利用しない方は、別途チケットを購入していただいて、駅内に入場してください。`
    },
    kansai_shop: {
      noteForPickupLocation: (url: string, className: string) =>
        `<a href=${url} target="_blank" rel="noopener noreferrer" class=${className}>関西空港の受取場所</a>は、「JR関西空港駅」構内にあります。`,
      noteForUsersWithoutJr: (className?: string) =>
        `※JR線を利用しない方は、<span class=${className}>別途チケットを購入していただいて</span>、駅内に入場してください。`
    },
    locker: {
      enter4number: `ロッカーのタブレットに表示されている４桁の数字をご入力ください。`,
      next: `次へ進む`,
      payAll: (amount: number, className: string) =>
        `支払う総額は<span class=${className}>JPY${commaedInteger(amount)}</span>になります。`,
      payRemainingAmount: `残額を支払う`,
      paymentDetail: `支払い詳細`
    },
    narita1_shop: {
      noteForPickupLocation: (url: string, linkClassName: string, boldClassName: string) =>
        `<a href=${url} target="_blank" rel="noopener noreferrer" class=${linkClassName}>成田機場第１ビルでの受取場所</a>は、「JR成田駅」構内にあります。\nモノレールを利用しない方は、別途<span class=${boldClassName}>チケットを購入</span>していただいて、駅内に入場してください。`
    },
    narita2_shop: {
      noteForPickupLocation: (url: string, linkClassName: string, boldClassName: string) =>
        `<a href=${url} target="_blank" rel="noopener noreferrer" class=${linkClassName}>成田空港ビル２での受取場所</a>は、「JR成田空港ビル１駅」構内にあります。\nモノレールを利用しない方は、別途<span class=${boldClassName}>チケットを購入</span>していただいて、駅内に入場してください。`
    },
    pickupItems: {
      note1: `購入予約者ご本人様のみが購入、お受け取りの手続きを実施頂けます`,
      note2: `購入予約者ご本人様のパスポート現物が必要となります。なお、パスポートはIC対応の物に限ります`,
      note3: `購入、お受け取りの手続きにはネット環境が必要となります。お客様にてご用意ください`,
      title: `商品受取りについて`
    }
  },
  orderstep: {
    step1: `ネットで\nショッピング`,
    step2: `予約手数料を\n支払う`,
    step3: `受取る場所で\n決済して受取り`,
    title: `ご利用の流れ`
  },
  payment: {
    cardValidUntil: `有効期限`,
    creditCardHolder: `カードホルダー`,
    creditCardNumber: `クレジットカード番号`,
    errorRegisteringCreditCard: `未能登錄信用卡`
  },
  pickupSupport: {
    cancel: `今回はキャンセルする`,
    cancellationFeeMayBeAdded: `キャンセル料を負担して頂く場合もございます。`,
    chooseOverseasShippingOrCancellation: `海外発送かキャンセルかを選択`,
    consumptionTaxMayBeAdded: `お問合せチャットに問題を送る`,
    contactUs: `お問合せをする`,
    deliver: `送ってもらって安心`,
    deliverOrCancel: `郵送もしくキャンセルをする`,
    deliverOverseasOrCancel: `海外郵送もしくキャンセルを申し込めます。`,
    flow: `手続きの流れ`,
    note: `※帰国後でも対応可能`,
    overseasShippingCostsMayBeAdded: `海外郵送の送料を負担して頂く場合もございます。`,
    pressTheButton: `お問合せボタンを押して手続き開始`,
    scanQrCode: `QRコードをスキャンする`,
    sendARequest: `問合せフォームから依頼を送る`,
    sendTheProblem: `お問合せチャットに問題を送る`,
    title: `安心サポート`,
    waitForCustomerSupport: `カスタマーサポートの連絡を待つ`
  },
  popularBrand: {
    title: `人気ブランド`
  },
  product: {
    shopping: `Shopping`
  },
  products: {
    FromPickUpDate: (year: string, month: string, day: string, hour: string, minute: string) =>
      `${year}年${month}月${day}日${hour}:${minute}分から`,
    alsoSearched: `この商品のお客様は以下も検索しました`,
    amountPaidAtReservation: `予約時の支払い金額`,
    amountPaidUponPickup: `受取時の支払い金額`,
    bestBefore: `賞味/使用期限`,
    bestBeforeDate: `賞味期限`,
    bookingFee: `予約手数料`,
    bookingFeeOfVendor: (vendor: string) => `${vendor}の予約手数料※1,2`,
    brand: `ブランド`,
    buyerComment: `バイヤーからのコメント`,
    customersAlsoSearched: `類似商品`,
    desc: `商品説明`,
    details: `内訳`,
    fastestDeliveryDate: (year: string, month: string, day: string, hour: string, minute: string) =>
      `最速送達時間：${year}年${month}月${day}日 ${hour} : ${minute}`,
    finalPayment: `受け取る時の決済額`,
    findOutMoreAboutWamazing: `WAmazingのサービスの特徴`,
    grossWeightGram: `重量`,
    ingredients: `成分/原材料`,
    loginToAddToCart: `商品をカートに追加するためには\nログインしてください。`,
    maxOrderCountAlert: `購入可能な数に達成しているため、これ以上の注文はできません。ご了承お願いします`,
    minimumBuyPerOrder: (minimum: number) => `1オーダあたり ${minimum} 点から購入可`,
    name: `商品名`,
    netContent: `内容量`,
    note1: `※商品によって、発注処理や出荷時間が異なり、受取日を早めることができます。`,
    orderLimitPerOrder: (limit: number) => `1オーダあたり ${limit} 点まで購入可`,
    outOfStock: `一時品切れ`,
    pay: `支払う`,
    payBookingFee: `予約手数料を決済`,
    point1: (className: string) => `旅行前に注文`,
    point2: (className: string) => `空港で受取り`,
    point3: (className: string) => `セルフ型免税`,
    price: `価格`,
    priceOfTaxFreeMerchandise: `免税品の商品代金`,
    productDescription: (product: string) =>
      `${product}のページ。日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`,
    productInfo: `商品情報`,
    productPriceOfVendor: (vendor: string) => `${vendor}の商品代金※3`,
    reason: `特徴`,
    sellingPriceTaxFree: `販売価格(免税)`,
    sellingPriceTaxIncluded: `販売価格(税込み)`,
    shippingDeadline: (year: string, month: string, day: string) =>
      `期間限定販売商品のため、受取り期限日は${year}年${month}月${day}日まで`,
    shiseido: `資生堂認定/nオンラインショップ`,
    showMoreServiceInformation: `どんなサービスなのか詳しく確認する`,
    size: `サイズ`,
    stockNotification: `入荷連絡`,
    stockNotificationDesc: `再入荷した場合は、ご登録のメールアドレスにメールでお知らせします。よろしいでしょうか？`,
    stockNotificationNotLogin: `再入荷通知を受取るには\n先にログインしてください。`,
    stockNotificationRegistered: `入荷連絡を登録完了しました！`,
    stockNotificationTitle: `再入荷通知を登録してよろしいでしょうか？`,
    taxFreePrice: `免税単価`,
    undiscountedPrice: `通常価格`,
    waitingReStock: `入荷待ち`,
    whyBuyFromWAmazing: `WAmazing免税買い物の特徴`,
    alcohol: {
      ageVerification: `・購入予約者ご本人様の年齢は20歳以上ですか？`,
      airportsWithAlcoholPickupRestrictions: `那覇空港、新千歳空港からお酒の受取りができません。`,
      alcoholContent: `アルコール度数`,
      confirm: `免税条件を\nご確認ください`,
      howToConfirm: `■確認できる箇所`,
      ingredients: `原材料`,
      japaneseLowDesc: `・日本の法律上、20歳未満の方にお酒の販売は禁じられています。`,
      pageDesc: `※酒類（販売元：東急百貨店）は販売元がWAmazing Shopと異なるため、酒類とWAmazing Shopの合計金額がそれぞれが5,000円以上である必要があります。`,
      passportAgeVerification: `※パスポートの年齢確認を行うことがあります。 その際、20歳未満の場合は販売できなくなりますのでご了承くださいませ。`,
      polishingRatio: `精米歩合`,
      productionArea: `生産地`,
      regardingSales: `■酒類の販売に関して`,
      regardingSalesDesc: (className: string) =>
        `・酒類（販売元：東急百貨店）は販売元が異なるため、酒類以外の商品と合計金額をまとめることができません。\n<span class=${className}>・酒類(販売元：東急百貨店)と酒類以外の商品の合計金額がそれぞれが5,000円以上である必要があります。それぞれの合計金額をご確認ください。</span>\n・酒類(販売元：東急百貨店)商品は下記の「確認できる箇所」の参照イメージからご参照ください。`,
      reminderForAlcoholImportTaxExemptionLimit: `ご自身の国/地域へお酒を持って入境する際、免税可能な量が決められています。ご自身でご確認をお願いします。`,
      storageMethod: `保管方法`,
      taxFreeAlcoholPurchaseThreshold: `お酒の販売主が違うため、商品購入の合計金額が5000円以上の場合だけ免税可能です。`,
      title: `酒類`,
      yesAge20: `はい、私は20歳以上です。`,
      flavor: {
        dry: `辛口`,
        sweet: `甘口`
      }
    },
    buyerCommentLabel: {
      title: `バイヤーズチョイス`,
      patch: {
        text: `コメント付き`
      }
    },
    chemicals: {
      confirm: `注意事項をご確認ください`
    },
    homeAppliance: {
      checkAgreement: `家電の同意事項を確認`,
      afterSupport: {
        title: `ご購入後の製品サポートについて`
      },
      brandSpecificRemarks: {
        title: `その他ブランド、商品毎の補足事項`
      },
      contactInfo: {
        desc: `製品に何か不具合がある場合、以下のお問い合わせフォームより、件名に免税ECを選択の上、ご連絡ください。`,
        details: `当社では、お客様都合による、返品・返金は受け付けておりません。\n正常なご使用状態で自然故障が生じた場合には、各社保証規定に準じた保証を致します。\n海外サポートを受け付けているメーカー商品については、保証期間内であれば、お住まい近くのメーカーカスタマサポートをご案内することが可能です 。\n各メーカーの保証内容については、保証書をご確認ください。`,
        title: `お問い合わせ先`
      },
      returnRefundPolicy: {
        desc: `初期不良品の場合、原則商品をご返品いただいた上で、返金対応を致します。\n商品受取後、10日以内に必ず上記の連絡先までご連絡をお願いします。商品の受取後、11日以降は初期不良としての対応が出来かねます。ご了承ください。`,
        mainTexts: `初期不良品の確認は、上記のお問い合わせ対応窓口にて実施させていただきます。その際、お客様に動画や画像等のご提供をお願いすることが御座います。※動画や画像をご提供いただけないと、返金・返品の対応が出来ない場合が御座います。\n返品時の送料はお客様負担にてお願いしております。`,
        title: `初期不良による返品・返金について`
      },
      returnRefundPolicyExtra: {
        desc: `弊社にて不具合、不良等の症状が確認出来ない場合は返金対応を致しかねることが御座います。`,
        mainTexts: `商品受取後のお客様都合の返品・返金は対応できかねます。\nお客様によって商品を何らかの形で加工された場合、ご返品もご返金もお受けできません`,
        title: `返品・返金対応について補足`
      },
      sendBackRepair: {
        desc: `商品の受取後、11日目以降に不具合が見つかり、ご連絡いただいた場合は「修理対応」とさせて頂いております。\n当社は「センドバック（send back）修理」（※注）にて保証期間内であれば無償修理対応します。`,
        mainTexts: `故障内容により有償修理になる場合も御座います。予めご了承ください。\n現物を当社指定場所まで送付いただき、メーカー保証に準じて修理し、再送致します。\n商品の返品送料、修理後の再送料につきましてはお客様負担にてお願いしております。\n※注　不具合が発生した製品を当社に送っていただき、修理等の対応のあとに製品を送り返すサービス方式です。`,
        title: `商品不具合による修理対応（send back）について                                `
      },
      sendBackRepairExtra: {
        remark: `弊社にて不具合、不良等の症状が確認出来ない場合は対応不可となります`,
        title: `修理対応について補足`,
        condition: {
          desc: `修理をご希望として返送いただいた現物を弊社並びにメーカーにて確認し、不具合、不良等の症状が確認出来なかった場合、修理対応不可となります。現物はそのまま再度梱包しお客様へ再送致しますのでご了承ください。（再送料は原則お客様ご負担となります）\n以下のような場合には保証期間内であっても有償修理となりますのでご注意ください。`,
          details: `ご購入の証明になる伝票類・保証書を紛失、または修理の際に提示を頂けない場合。\n不適切な取り扱い（取り付け）により生じた故障および破損\n水濡れ、落下や圧力（足で踏み潰した等）により生じた故障および破損\n改造や正規な修理以外の修理により生じた故障および破損\n火災、震災、風水害、落雷、その他天変地変により生じた故障および破損\n輸送時に生じた故障および破損\n停電や落雷、異常な高電圧により生じた故障および破損\n設置された、その他の機器が原因となり生じた故障および破損`
        }
      },
      sony: {
        desc: `世界47カ国で国際保証（修理対応）を受け付けています。当社にご連絡いただき次第、その後のお手続きをお知らせいたします。対象国は以下リンクよりご確認ください`,
        title: `SONY`
      },
      watch: {
        brandList: (
          seikoUrl: string,
          citizenUrl: string,
          seikoEpsonUrl: string,
          anchorTagClassName: string,
          listTagClassName: string
        ) =>
          `<li class=${listTagClassName}>セイコーウオッチ株式会社: <a href=${seikoUrl} class=${anchorTagClassName} target='_blank'>${seikoUrl}</a>（保証期間１年）</li>\n<li class=${listTagClassName}>シチズン時計株式会社: <a href=${citizenUrl} class=${anchorTagClassName} target='_blank'>${citizenUrl}</a>（保証期間１年）</li>\n<li class=${listTagClassName}>セイコーエプソン株式会社（オリエント）: <a href=${seikoEpsonUrl} class=${anchorTagClassName} target='_blank'>${seikoEpsonUrl}</a>（保証期間１年）</li>`,
        desc: `メーカー保証に準じた対応を致します。\n各社保証内容は以下リンクよりご確認ください。`,
        title: `時計`,
        precaution: {
          mainTexts: `バンドをお客様ご自身で調整したものは保証対象外となります\n【自動巻き・キネティック】時計は、振動を動力として発電、蓄電をしております。長時間使っていない場合や、一日数時間程度の使用の場合は停止したり、時間(秒針)にズレ等が発生する場合がございます。再度、振動(発電)を行って確認してください。(振動：腕時計を数分振って振動するようにしてください)\nクオーツ式時計の場合は、お買上げ頂いた時計に組み込まれている電池は、機能や性能をチェックする為のモニター電池となっております。その為、お買上げ後、所定の期間の電池寿命がないことがございます。\n腕時計の【限定品】及び【機械式腕時計/手巻き腕時計】【高額商品】は受取後のお客様都合の返品は承っておりません。ご了承ください。`,
          title: `付随した注意事項`
        }
      }
    },
    medicine: {
      Ingredients: `成分・分量`,
      Inquiries: `お問い合わせ先`,
      InquiriesForClick: `お問い合わせはこちら`,
      administration: `* 用法・用量`,
      consult: `* 相談すること`,
      contraindications: `* してはいけないこと`,
      couponText: (rate: number) => `表示価格より${rate}%OFF`,
      discountText: `医薬品10%OFF`,
      distributorContact: `製品問い合わせ先`,
      effects: `* 効能・効果`,
      notice: `※購入前に「注意事項」を必ずお読みください。\n※オンラインショップでは、医薬品（販売元：スギ薬局 川口戸塚店）の免税販売は法律で禁じられているため、すべての医薬品は税込価格での販売となります。WAmazingでは現在、医薬品は全て課税分の金額を決済時に自動割引になるキャンペーン実施中です。\n※薬品(販売元：スギ薬局)のみ購入する場合、1000円以上の商品を購入する必要があります。`,
      other: `* その他の注意`,
      precautions: `* 保管及び取り扱い上の注意`,
      shelfLife: `* 使用期限`,
      Information: {
        desc: (category: string, className: string) =>
          `・この商品は「${category}」に分類されています。購入時にはサイト上に表示している<span class=${className}>「してはいけないこと」と「相談すること」及び「用法・用量」を守り、「使用上の注意」を必ずご確認の上、注文手続きをお願いします。</span>\n・医薬品についてご不明点がございましたら、ご購入前に医師・薬剤師・登録販売者にご相談ください。\n※当店で販売する医薬品は、使用期限が最短でも６カ月以上のものを販売しております。`,
        title: `医薬品販売に関する案内`
      },
      abused: {
        desc: `以下対象成分を含む医薬品は、濫用によるお客様の健康被害を防ぐため、法令に基づき、以下の事項の確認が義務付けられております。また、法令に基づき、販売数量はおひとり様1個までとなっております。`,
        title: `濫用等のおそれのある医薬品が含まれています。購入前に以下の注意事項をご確認ください。`,
        confirm: {
          least18years: `①お薬のご購入者は18歳以上です`,
          notBoughtAnyMedicine: `②今回購入のお薬と同じ効能・効果のお薬を他の薬局等で購入してないです`,
          notMadeConsecutive: `③今回購入のお薬や同じ効能・効果のお薬を継続購入・継続服用してないです`,
          title: `■購入者または使用者に関する確認事項`
        },
        ingredient: {
          desc: `・エフェドリン・コデイン・ジヒドロコデイン・ブロムワレリル尿素・メチルエフェドリン・プソイドエフェドリン`,
          title: `■濫用等のおそれのある成分\n（以下の成分を含む医薬品が対象です。）`
        }
      }
    },
    notice: {
      expectedRestockDate: (year: number, month: number, day: number) =>
        `こちらの商品は、<em>${year}年${month}月${day}日</em>に再入荷予定です`,
      restockDateUndetermined: `こちらの商品は、再入荷日<em>未定</em>となっております`,
      restockDateUndeterminedShort: `再入荷日未定`,
      restockNotificationEmail: `商品の再入荷通知は登録されたメールアドレスに送信されます。`,
      restockNotificationEmailNote: `※再入荷日は前後する場合がございます。`,
      restockNotificationSet: `再入荷通知設定済み`,
      restockNotificationSetup: `再入荷通知設定が完了しました`,
      scheduledArrival: (month: number, day: number) => `${month}月${day}日 入荷予定`,
      wishRestockNotification: `再入荷通知を希望する`
    },
    originalPoint: {
      title: (product: string) => `${product}のオリジナルポイント`
    },
    promo: {
      labelText: `期間限定10％割引`
    },
    sort: {
      popular: `人気順`,
      priceAsc: `安い順`,
      priceDesc: `高い順`
    },
    tokyuStore: {
      liquorLp: {
        brewery: `蔵元`,
        description: `WAmazing shopは東急百貨店と連携し、日本各地から伝統と革新に満ちた蔵元が作る良質な日本酒をお届けいたします。`,
        intro: `日本各地には、知る人ぞ知る隠れた地酒や、一般の流通では中々目にすることが 出来ない珍しい地酒が沢山。WAmazing shopは東急百貨店と連携し、日本各地から伝統と革新に満ちた蔵元が作る良質な日本酒をお届けいたします。`,
        otherRecommendedSake: `他に\nおすすめの\n日本酒`,
        recommendedWayToDrink: `おすすめの飲み方`,
        title: `良質な日本酒`,
        typeOfSake: `日本酒の種類`,
        dassai: {
          alcoholContent: `15`,
          brandName: `DASSAI（獺祭）`,
          brewery: `旭酒造株式会社`,
          breweryDesc: `大量販売の論理から生まれた酔えばいい、売れればいい酒ではなく、おいしい酒・楽しむ酒を目指してきました。何より、酒のある楽しい生活を提案する酒蔵であり続けたいと考えています。`,
          breweryDescTitle: `酔うため、売るための酒ではなく、\n味わう酒を求めて`,
          breweryUrl: `https://www.asahishuzo.ne.jp/about/`,
          breweryUrlTitle: `引用元　旭酒造株式会社HP`,
          characteristic: `23%という極限まで磨いた山田錦を使い、最高の純米大吟醸`,
          ingredients: `山田錦100%、米麹`,
          netContent: `720mL`,
          polishingRatio: `23`,
          price: `5700`,
          productDesc: `華やかな上立ち香と口に含んだときのきれいな蜂蜜のような甘み、飲み込んだ後口はきれいに切れていきながらも長く続く余韻。獺祭のフラッグシップ。`,
          productName: `獺祭 純米大吟醸 磨き二割三分 木箱入り 720mL`,
          productionArea: `山口県`,
          recommendedWayToDrink: `冷酒・常温`,
          storageMethod: `温度差のない冷暗所\n長期保管の場合は冷蔵推奨`,
          typeOfSake: `純米大吟醸`
        },
        hakkaisan: {
          alcoholContent: `17`,
          brandName: `HAKKAISAN（八海山）`,
          brewery: `HAKKAISAN BREWERY（八海醸造）`,
          breweryDesc: `国内有数の豪雪地帯・新潟魚沼地方にて大正11年創業。\n霊峰八海山の恵みを受けた極軟水「雷電様の清水」を仕込み水として、“淡麗で飲み飽きせず食事とともにコミュニケーションを引き立たせる食中酒”をつくり続けています。`,
          breweryDescTitle: `食事を邪魔せず、いつまでも飲み飽きない酒づくり`,
          breweryUrl: `https://ec-hakkaisan.com/pages/about`,
          breweryUrlTitle: `引用先　八海山公式HP`,
          characteristic: `淡麗な中にもうまみをたたえた味わい。\n浩和蔵仕込の純米大吟醸です。`,
          ingredients: `米（兵庫県産 山田錦）・米麹`,
          netContent: `720mL`,
          polishingRatio: `45`,
          price: `6000`,
          productDesc: `品質に対する一切の妥協を許さず、蔵人の技術と情熱を惜しみなく注ぎ込みました。淡麗な中にもうまみをたたえた味わい。料理の味を引き立てる「日本の日本酒」として、日本はもちろん世界のテーブルで機能していく酒を目指しています。`,
          productName: `八海山純米大吟醸浩和蔵仕込720mL`,
          productionArea: `新潟県`,
          recommendedWayToDrink: `冷酒・常温`,
          storageMethod: `温度差のない冷暗所\n長期保管の場合は冷蔵推奨`,
          typeOfSake: `純米大吟醸`
        },
        imayoTsukasa: {
          alcoholContent: `17`,
          brandName: `Imayo Tsukasa（今代司）`,
          brewery: `Imayo Tsukasa（今代司酒造）`,
          breweryDesc: `今代司酒造は1767年 初代但馬屋十左ェ門が創業。当初は酒の卸し業や旅館業、飲食業を商いにしていました。\n江戸後期から明治初期の新潟は、北前船が頻繁に寄港し人口が江戸より多かったといわれています。そのため新潟の街は活気に溢れ、その新潟の地にある今代司も共に繁栄していくこととなりました。`,
          breweryDescTitle: `日本酒発信基地として多くの方に愛される蔵元`,
          breweryUrl: `https://www.imayotsukasa.com/pages/aboutus`,
          breweryUrlTitle: `引用元　今代司酒造株式会社公式HP`,
          characteristic: `日本の魅力を錦鯉と日本酒のコラボレーションを実現。\nデザイン賞も受賞したギフトにおすすめの日本酒です。`,
          ingredients: `米(国産)、米麹(国産米)　`,
          netContent: `720mL`,
          polishingRatio: `0`,
          price: `5600`,
          productDesc: `日本酒「錦鯉」は、錦鯉のように華やかで、清らかさの中に堂々とした味を感じられるお酒です。\n頭で飲む人が増えてしまった現代へのアンチテーゼとして、\n酒のスペックは非公開。\n頭で味や香りを捉えるのではなく、鼻と口、そして目で、純粋にお楽しみいただく新しい日本酒です。`,
          productName: `今代司「錦鯉」箱入り 720mL`,
          productionArea: `新潟県`,
          recommendedWayToDrink: `冷酒`,
          storageMethod: `温度差のない冷暗所\n長期保管の場合は冷蔵推奨`,
          typeOfSake: `非公開`
        },
        mizubasho: {
          alcoholContent: `13`,
          brandName: `MIZUBASHO（水芭蕉）`,
          brewery: `Nagai Sake（永井酒造）`,
          breweryDesc: `創業明治19年。日本の先人たちが大切にしてきた自然や米文化、それらから醸し出された日本酒を、新しいスタイルとして世界に挑戦しています。`,
          breweryDescTitle: `日本酒の新たな可能性を提案する蔵元`,
          breweryUrl: `https://nagai-sake.co.jp/`,
          breweryUrlTitle: `引用元　永井酒造株式会社公式HP`,
          characteristic: `構想から10年、数百回にも及ぶ試行錯誤の中、誕生。シャンパンと同じ製法で造られたスパークリング清酒です。`,
          ingredients: `米(国産)、米麹(国産米)　`,
          netContent: `720mL`,
          polishingRatio: `0`,
          price: `5255`,
          productDesc: `シャンパンのようなきめ細やかな泡と華やかで上品な味わい。伝統的な日本酒製法に瓶内二次発酵を取り入れた、本格的なスパークリング清酒。世界のトップシェフ達が「初めての食感」と驚愕する逸品。チェリーやライチの香味を持ち、シルキーな泡が妖精のように料理を包み込みます。`,
          productName: `MIZUBASHO PURE 720mL`,
          productionArea: `群馬県`,
          recommendedWayToDrink: `冷酒`,
          storageMethod: `温度差のない冷暗所\n長期保管の場合は冷蔵推奨`,
          typeOfSake: `発泡性清酒`
        },
        otherRecommendation: {
          moreRecommendedSake: `おすすめ日本酒をもっと確認する`
        },
        sakeIntro: {
          classBasics: `特定名称酒は普通酒よりも原料にこだわり、①お米の精米歩合（どれくらい磨いているか）、②吟醸造りをしているか、③醸造用アルコールを含んでいるかによってクラス分けされます。`,
          daiginjo: `大吟醸酒`,
          forBeginner: `日本酒を飲み始めたばかりの頃は「独特な風味が苦手」だと感じる方も多いため、日本酒初心者の方は、精米歩合が低い種類のお酒がおすすめです。`,
          futsushu: `普通酒`,
          ginjo: `吟醸酒`,
          honjozo: `本醸造酒`,
          junmaiDaiginjo: `純米大吟醸酒`,
          junmaiGinjo: `純米吟醸酒`,
          junmaishu: `純米酒`,
          polishing: `一般的に精米歩合が低い（酒米を沢山削る）方が、雑味が少なくスッキリした味わいで、香りが高い上品な日本酒が多いです。たくさんお米を削ることで、タンパク質や脂質などを取り除き、よりクリアな味わいになるためです。`,
          polishingRatioAnnotation: `＊精米歩合とは「精米歩合とは、精米（玄米から表層部を削った米）して残った米の割合を％で表したもの`,
          title: `日本酒の\n種類について`,
          jozo: {
            ingredients: `米、水、米麹、醸造用アルコール`
          },
          junmai: {
            ingredients: `米、水、米麹`
          }
        },
        shochikubai: {
          alcoholContent: `15`,
          brandName: `Sho Chiku Bai（松竹梅）`,
          brewery: `TAKARA SHUZO（宝酒造）`,
          breweryDesc: `豊穣な大地、ふりそそぐ太陽や雨などの自然が育んだ田畑の恵みこそ、かけがえのない宝物として尊んできました。品質にこだわり、自然の恵みに感謝し、丁寧に商品を仕上げています。`,
          breweryDescTitle: `京都・伏見　老舗酒造メーカー`,
          breweryUrl: `https://www.takarashuzo.co.jp/takarahatakara/`,
          breweryUrlTitle: `引用元　宝酒造公式HP`,
          characteristic: `老舗メーカーによる、“松竹梅”の慶祝イメージを活かしたブランドです。`,
          ingredients: `米(国産)、米麹(国産米)　`,
          netContent: `1800mL`,
          polishingRatio: `0`,
          price: `5317`,
          productDesc: `お祝いの場にふさわしい伝統の容器角樽入りの松竹梅 本醸造酒で、軽快でなめらかな味わいが特長です。`,
          productName: `松竹梅 「祝樽」1.8L`,
          productionArea: `京都府`,
          recommendedWayToDrink: `ぬる燗・熱燗`,
          storageMethod: `温度差のない冷暗所\n長期保管の場合は冷蔵推奨`,
          typeOfSake: `本醸造酒`
        }
      }
    }
  },
  question: {
    answerCount: (count: number) => `回答（${count}）件`,
    answerReceived: `回答が送信されました！`,
    answerUsefulThings: `役に立つ本当の思いことを回答しましょうか`,
    askEveryone: `みんなに聞いてみよう`,
    assistOthers: `他の方を助けて、質問を回答しよう`,
    completed: `完了`,
    mayBeDeleted: `※不適切な質問・回答である場合、WAmazing免税買物運営者より削除される場合がございますので、ご了承をお願い致します。\n`,
    notifiedViaEmail: `お客様の質問に対する回答は頂いたメールで通知されます。`,
    post: `投稿する`,
    postDetailedQuestion: `詳細な質問を投稿すると、より正確な回答をもらえます。`,
    postQuestion: `質問を投稿`,
    questionsMayBeAnsweredByWAmazing: `投稿した質問はWAmazingの担当者が回答する場合があります。`,
    received: `質問を受け取りました。`,
    responseWillBeNotified: `お客様の回答は質問者に通知させていただきます。`,
    thankYouForAnswer: `役に立つ情報を投稿いただき、誠にありがとうございました！`
  },
  questionnaire: {
    aboutTheSurvey: `アンケートの回答について`,
    afterYouPicked: (answer: string, coupon: string) =>
      `※荷物受取り完了後に、<span class=${answer}>アンケート回答したら</span><span class=${coupon}>1000円クーポン</span>もらえます。`,
    answer: `回答する`,
    answerAfterPaid: `もしくは残額の支払いが終わったあとに、受信するメールの導線から回答する`,
    answerFromOrder: `注文詳細画面の導線から回答する`,
    coupon: (className?: string) => `<span class=${className}>1000円分 </span>クーポン`,
    fiveSecond: `5秒で簡単`,
    get: `獲得\n`,
    pickUpCompleted: `荷物の受取りが完了に`,
    popup: (url: string, className: string) =>
      `買いたい商品の<a href=${url} class=${className} target='_blank'>アンケート調査</a>に\nご協力をお願い致します！`,
    survey: `アンケート /アンケートに回答して`
  },
  questionnaireModal: {
    fiveSecond: `5秒で簡単アンケート`,
    getCoupon: `1000円のクーポンをGETしよう`,
    todayNotShow: `本日は表示しない`
  },
  ranking: {
    description: `人気商品のランキング一覧。日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`,
    popular: `人気ランキング`,
    title: `ランキング`,
    titleName: `ランキング`,
    meta: {
      title: `人気の日本商品ランキング`
    }
  },
  receive: {
    vjwRegistrationInfo: `<div class="text-sm mt-2.5">指定施設にて免税手続きを行うためには日本に<span class="text-primary">入国後Visit Japan Web（VJW）登録が必須</span>になります</div>`,
    detail: {
      address: `住所`,
      counterDescription: `日本全国のホテルなどで対面にて手続きを行い商品を受け取る`,
      lockerDescription: `日本全国の空港・駅・バスターミナルなどに設置されている無人ロッカーにて簡単に商品が受け取る`,
      map: `マップ`,
      notRequired: `不要`,
      pickupAvailableTime: `お受取り可能時間`,
      pickupLocationDetail: `受取り場所詳細`,
      pickupLocationInfo: `受け取り場所情報`,
      receiveAtCounter: `対面で受け取る`,
      receiveAtLocker: `ロッカーで受け取る`,
      required: (url: string) =>
        `必須（<a class="underline" href=${url} arget="_blank" rel="noopener noreferrer" >登録のやり方を確認</a>）`,
      view: `詳細をみる`,
      viewOnMapApp: `マップアプリで見る`,
      vjwRegistration: `VJWの登録`,
      vjwRequiredNote: `※VJW登録必須`
    },
    list: {
      pickupLocation: `受け取り場所`,
      popularRegions: `人気の地域`,
      selectPickupLocation: `受け取り場所を選択`
    },
    navigation: {
      backToPickupList: `受け取り場所の一覧に戻る`,
      next: `次へ`,
      select: `選択`
    },
    vjw: {
      counterInfo: (url: string) =>
        `・対面受け取りにて免税手続きを行うためには<span class="text-primary font-medium">日本に入国後<a href=${url} target="_blank" rel="noopener noreferrer" class="underline">VJW（Visit Japan Web）登録</a>が必須</span>になります`,
      pleaseCheck: `必ずご確認お願いします。`,
      registrationRequired: `■Visit Japan Webの登録をお願いします`
    }
  },
  recommended: {
    description: `ワメイジングの選ぶ日本の人気商品一覧。日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`,
    mustBuyPopularJapaneseGoods: `絶対買う日本人気商品`,
    popularJapaneseCosmetics: `日本の人気スキンケア・化粧品`,
    popularJapaneseSnacks: `日本の人気お菓子・スナック`,
    popularProducts: `おすすめの人気商品`,
    title: `おすすめの日本免税商品一覧`,
    viewMorePopularCosmetics: `人気スキンケア商品・化粧品をもっと見る`,
    viewMorePopularSnacks: `人気お菓子・スナックをもっと見る`,
    cosmetics: {
      description: `WAmazingオンライン免税店では、日本で人気・おすすめのスキンケア・化粧品ブランドを豊富に取り揃えています。サイト内で欲しい商品を探して一度にまとめて購入可能！お土産選びの時間を節約したい人にぴったりです。購入した商品は指定の空港や場所で受け取りが可能。大きな荷物を運ばずに済むので、日本旅行がさらに快適になります。`
    }
  },
  recommendedArticles: {
    title: `おすすめ関連記事`
  },
  referral: {
    label: `TODO: referral.label@ja`,
    pageDescription: `TODO: referral.pageDescription@ja`,
    pageTitle: `TODO: referral.pageTitle@ja`,
    startShopping: `TODO: referral.startShopping@ja`
  },
  registerCampaign: {
    campaignInProgress: `キャンペーン実施中`,
    entryAndRegister: `エントリーして\n新規会員登録すると`,
    fiveHundredOff: (border: string, thousand: string, yen: string, off: string) =>
      `<span class=${border}><span class=${thousand}>500</span><span class=${yen}>円</span></span><span class=${off}>OFF</span>`,
    fiveHundredOffForBanner: (discount: string, coupon: string) =>
      `<span class=${discount}>500円</span><span class=${coupon}>OFFクーポン</span>`,
    getCouponByEntryAndRegistration: `エントリーして\n新規会員登録すると\nクーポンがもらえる!`,
    signUpAndGetCoupon: (className: string) => `今なら<span class=${className}>1000円クーポンもらえる！</span>`
  },
  reviewSubmit: {
    button: `クチコミを投稿する`,
    howLike: `この商品はいかがでしたか？`,
    optional: `任意`,
    pleaseLogin: `クチコミをするために、先にログインしてください。`,
    required: `必須`,
    thanksForReview: `クチコミの投稿ありがとうございました`,
    guide: {
      agree: (button: string) => `クチコミ投稿に関する${button}に同意します`,
      button: `注意事項`,
      content: `・口コミ投稿機能の利用に際しては、口コミ投稿機能が以下の趣旨に基づくものであることをご理解の上、投稿ください。\n・投稿者がその商品を主観的に評価し、評価点の設定と口コミが投稿できる場であること\n・投稿者の経験に基づく口コミの情報を収集する場であること\n・余分な文字やスペース、ひらがな、アスキーアートを多用した本文、改行はなるべく使わないようにしてください。\n・以下の内容を含む口コミを投稿してはならないものとし、以下の内容を含む口コミが投稿された場合、弊社は、当該口コミの削除、編集その他弊社が必要と判断する措置を講じることができるものとします。\n　・弊社、サービス提供者または第三者の著作権、名誉、プライバシー、肖像権その他の権利を侵害しまたはそのおそれのある内容\n　・弊社、サービス提供者または第三者を差別、誹謗中傷し、または名誉もしくは信用を毀損する内容\n　・犯罪行為に結びつく、または助長する内容\n　・法令や公序良俗に反する内容\n　・営利宣伝目的を含む内容\n　・特定の政治的または宗教的主張を含む内容\n　・差別的表現を含む内容\n　・わいせつ、有害、下品、その他第三者に嫌悪感を与える内容\n　・その他弊社が不適切と判断する内容\n・口コミは各言語に翻訳してWAmazing Shoppingのページに掲載いたします。ページへの掲載有無は弊社で判断いたします。\n・弊社は、投稿された口コミの内容を、口コミ投稿者に通知することなく、自由に転載、引用、開示、提供、出版、配信その他の方法により、無償で利用することができるものとします。また、口コミ投稿者は、当社および当社の指定する者に対し、口コミにかかる著作者人格権を行使しないことに同意するものとします。\n・弊社は、投稿された口コミの内容を、口コミ投稿者に通知することなく、削除し又は非表示にすることができるものとします。この場合、弊社は、削除又は非表示とした理由についての説明義務を負わないものとします。\n・口コミ投稿者は、当該口コミの内容に関して一切の責任を負うものとし、弊社は口コミの内容に関して、その正確性・信頼性・合法性・完全性・有用性など一切の事項についていかなる責任も負いません。\n・投稿された口コミに関する問い合わせ、クレーム、請求等のトラブルについては、口コミ投稿者が自己の責任と負担で解決し、弊社に一切迷惑をかけないものとします。\n・本注意事項に定めのない事項については、WAmazing利用規約に従うものとし、\n個人情報の取扱に関しては、プライバシーポリシーに従うものとします。`,
      title: `注意事項`
    },
    label: {
      comment: `コメント`,
      nickname: `ニックネーム`,
      title: `タイトル`
    },
    placeholder: {
      comment: `例：商品の味、使いやすさ`,
      name: `表示させるネームを入れてください`,
      title: `タイトルを入れてください`
    }
  },
  reviewSummary: {
    anonymous: `名前なし`,
    count: (count: number) => `${count}件`,
    productName: (productName: string) => `${productName}のクチコミ`,
    reviewCount: (count: number) => `${count}件のクチコミ`,
    shareReview: `この商品の情報をみんなに共有しましょう`,
    showOriginal: `原文を表示`,
    showTranslated: `翻訳を表示`,
    title: `クチコミ`,
    userName: (userName: string) => `${userName}さん`,
    age: {
      fifty: `50代`,
      forty: `40代`,
      sixty: `60代以上`,
      ten: `10代以下`,
      thirty: `30代`,
      title: `年齢`,
      twenty: `20代`
    },
    gender: {
      female: `女性`,
      male: `男性`,
      other: `指定しない`,
      title: `性別`
    }
  },
  sakeNotice: {
    text1: `年齢確認`
  },
  search: {
    brandOrProductOrProduct: `ブランド、商品名、型番etc`,
    enterKeywordsAlert: `検索したい商品名などのキーワードをご入力ください。`,
    history: `検索履歴`,
    keyword: `キーワード`,
    noResultFor: (keyword: string) =>
      `「${keyword}」の検索に一致する商品はありませんでした。\nキーワードが正しく入力されていても一致する商品がない場合は、別の言葉をお試しください。`,
    popularKeywords: `人気キーワード`,
    recommendedKeywords: `おすすめのKW`,
    search: `検索`,
    searchItems: `商品検索`,
    searchResultFor: (keyword: string) => `「${keyword}」の検索結果`,
    searchingFor: (keyword: string) => `「${keyword}」を検索しています……`,
    meta: {
      description: `検索結果一覧。日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`,
      title: `検索結果一覧`
    }
  },
  service: {
    useFreeECshopTitle: `WAmazing免稅EC服務使用規則`
  },
  shops: {
    commonMapDescription: (className: string) =>
      `※ご注文はお受け取り日の<span class=${className}>3ヶ月前まで可能</span>です。\n※<span class=${className}>日本へ旅立つ前に購入可能です。</span>\n※表示時刻は日本時間です。`,
    list: `店舗一覧`,
    mapTitle: `受取り場所案内`,
    pickupAvailableDates: `受け取り可能日`,
    placeholder: `受け取り店舗を選択してください･･･`,
    centrair_shop: {
      listPickupLocation: `中部国際空港-アクセスプラザ2F`,
      lockersLocation: `中部国際空港受取り案内地図`,
      routeInformationByBusTaxi: `経路案内(バス、タクシーを利用する方へ)`,
      routeInformationByTrain: `経路案内(電車を利用する方へ)`,
      route: {
        busTaxi: {
          step1: `①降車後、第1ターミナルの2階まで上がって頂き、アクセスプラザ方向に向かってください。`,
          step2: `②アクセスプラザに入って、そのまま直進してください。`,
          step3: `③道に沿って一番奥まで直進します。`,
          step4: `④一番奥のブースに、受取の免税ロッカーが設置されています。`,
          step5: `⑤WAmazingの免税ロッカーは手前になります。楽しい、楽な免税買物を体験しましょう！`
        },
        train: {
          step1: `①降車後、改札口から出て、すぐ左手の方向に進んでください。`,
          step2: `②道に沿って直進します。`,
          step3: `③一番奥のブースに、受取の免税ロッカーが設置されています。`,
          step4: `④WAmazingの免税ロッカーは手前になります。楽しい、楽な免税買物を体験しましょう！`
        }
      }
    },
    hakata_station_shop: {
      listPickupLocation: `JR博多駅受取り案内地図`,
      lockersLocation: `2Fのひかり広場内`,
      routeInformationByBulletTrain: `経路案内(新幹線博多駅を利用する方へ)`,
      routeInformationByCar: `経路案内(車を利用する方へ)`,
      routeInformationByJR: `経路案内(JR博多駅を利用する方へ)`,
      route: {
        finish: (number: string) =>
          `${number}WAmazingの免税ロッカーをご覧になります。\n楽しい、楽な免税買物を体験しましょう！`,
        bulletTrain: {
          step1: `①改札口を出て正面にあるコーヒーショップの左側にお進みください。`,
          step2: `②左側にロッカーが見えてきます。`
        },
        car: {
          step1: `①入り口に入ってすぐ右に進んでください。`,
          step2: `②右側にあるエスカレーターに乗って2階にお進みください。`,
          step3: `③2階で降りて前方の右側にお進みください。`,
          step4: `④左側にロッカーが見えてきます。`
        },
        jr: {
          step1: `①改札口を出てチケット売り場の右に進んでください。`,
          step2: `②そのまままっすぐにお進みください。`,
          step3: `③左側にあるエスカレーターに乗って2階にお進みください。`,
          step4: `④2階で降りて前方の右側にお進みください。`,
          step5: `⑤左側にロッカーが見えてきます。`
        }
      }
    },
    haneda_shop: {
      listPickupLocation: `羽田空港第3ターミナルでの受取り案内地図`,
      lockersLocation: `モノレール羽田空港第3ターミナル駅構内図`,
      lockersLocationNotice: `※エレベーターのご利用希望する方は空港インフォメーションに確認してください。`,
      routeInformationByBusTaxi: `経路案内(バス、タクシーを利用する方へ)`,
      routeInformationByKeikyu: `経路案内(京急線を利用する方へ)`,
      routeInformationByMono: `経路案内(モノレールを利用する方へ)`,
      route: {
        busTaxi: {
          step1: `①１Fの降り場から、２Fの到着ロビーに上がって頂き、２Fにあるモノレール駅に向かってください。`,
          step2: `②モノレールの発券機に180円の入場券をご購入頂き、改札に入ってください。`,
          step3: `③改札に入ってすぐ左手前にWAmazingの受け取りロッカーがあります。楽しい、楽な免税買物を体験しましょう！`
        },
        keikyu: {
          step1: `①降車後、出口の方向に向かい、改札から出てください。`,
          step2: `②そのまま直行し、左手前のエスカレーターに乗って、２階まで上がってください。`,
          step3: `③エレベーターから降り、2F到着ロビーのサインに従い左に曲がってください。`,
          step4: `④到着ロビーのサインに従い直進すると、モノレールの駅が見えてきてます。迂回してモノレールの方向に向かってください。`,
          step5: `⑤モノレールの発券機に180円の入場券をご購入頂きたら、改札に入ってください。`,
          step6: `⑥改札に入ってすぐ左手前にWAmazingの受け取りロッカーがあります。楽しい、楽な免税買物を体験しましょう！`
        },
        mono: {
          step1: `①降車後、出口の方向に向かいエスカレーターで２Fまで降りてください。`,
          step2: `②道に沿って左へ曲がります。`,
          step3: `③WAmazingの免税ロッカーは手前になります。楽しい、楽な免税買物を体験しましょう！`
        }
      }
    },
    hiroshima_shop: {
      listPickupLocation: `広島空港での受取り案内地図`,
      lockersLocation: `2Fの国際出発ロビー`,
      routeInformationByBus: `経路案内(広島空港駅(バス)を利用する方へ)`,
      routeInformationByInternational: `経路案内(国際線到着からのルート)`,
      route: {
        bus: {
          step1: `①バスから降りて、エスカレーターに乗り、2階の右手の国際出発ロビーにお進みください。`,
          step2: `②真ん中のソラミィ広場を通って、右側の「外貨両替」店舗方向へ進めてください。`,
          step3: `③外貨両替店舗の左側にロッカーが見えてきます。`,
          step4: `④WAmazingの免税ロッカーをご覧になります。\n楽しい、楽な免税買物を体験しましょう！`
        },
        international: {
          step1: `①国際線到着後に、到着ロビー中のエスカレーターで２階に上がり、左手へ曲がり進めてください。`,
          step2: `②右側の外貨両替店舗方向へ進むと、左側にロッカーが見えてきます。`,
          step3: `③WAmazingの免税ロッカーをご覧になります。\n楽しい、楽な免税買物を体験しましょう！`
        }
      }
    },
    kansai_shop: {
      listPickupLocation: `JR関西空港駅構内図`,
      lockersLocation: `関西空港ロッカーの設置場所の案内地図`,
      routeInformationByJR: `経路案内(JR線を利用する方へ)`,
      routeInformationByOthers: `経路案内(JR線以外の交通を利用する方へ)`,
      route: {
        jr: {
          step1: `①降車後、ホームから２階（改札階）まで上がってください。`,
          step2: `②２F改札階に上がると、大きめの地図看板がございます。そちらの左手前に進みます。`,
          step3: `③進みますと手前にATMがあります。そちらの後ろに回ってください。`,
          step4: `④ATMの後ろへ回ったら、WAmazingの免税ロッカーをご覧になります。 楽しい、楽な免税買物を体験しましょう！`
        },
        others: {
          step1: `①関西国際空港第1ターミナル到着したら、２Fにある「JR関西空港駅」へ向かってください。`,
          step1note: `*リムジンバスご利用の方：第1ターミナルビル4F国際線出発フロアに到着したら、２Fに降りてください。\n *船ご利用の方：関西空港のポートターミナルに到着しましたら、専用シャトルバスにご乗車し、第1ターミナルビル4F国際線出発フロアに到着したら、２Fに降りてください。`,
          step2: `②地下鉄きっぷ売り場にて、右側にある青看板部分のJRきっぷ売り場に向かってください`,
          step3: `③発券機で150円の改札切符を購入し、背後にあるJR改札内にご入場頂いてください。`,
          step4: `④改札に入ると目の前に大きめの地図看板がございます。そちらの左手前に進みます。`
        }
      }
    },
    mapDescription: {
      centrair_shop: (className: string) =>
        `WAmazing免税ロッカーは、<span class=${className}>中部国際空港-アクセスプラザ２F</span>に設置されております。`,
      hakata_station_shop: (className: string) =>
        `WAmazing受取りロッカーは、「JR博多駅」<span class=${className}>2Fのひかり広場内</span>に設置されております。`,
      haneda_shop: (className: string) =>
        `WAmazing受取りロッカーは、羽田空港第3ターミナル２F到着階にある<span class=${className}>「モノレール改札内」</span>に設置されております。\n\n<span class=${className}>※モノレールのご利用をお勧めします。\n※モノレールを利用しない方は、別途チケットを購入頂き、駅内に入場してください。</span>`,
      hiroshima_shop: (className: string) =>
        `WAmazing受取りロッカーは、「広島空港」<span class=${className}>2Fの国際出発ロビー</span>に設置されております。`,
      kansai_shop: (className: string) =>
        `WAmazing受取りロッカーは、の<span class=${className}>「JR関西空港駅」</span>改札内の2Fに設置されております。\n\n<span class=${className}>※JR線のご利用をお勧めします。\n ※JR線を利用しない方は、別途チケットを購入していただいて、駅内に入場してください。</span>`,
      naha_station_shop: (className: string) =>
        `WAmazing受取りロッカーは、「那覇空港」<span class=${className}>2Fのフリーコンセントコーナー</span>に設置されております。`,
      narita1_shop: (className: string) =>
        `WAmazing免税ロッカーは、<span class=${className}>成田空港第1ターミナルJR成田空港駅</span>に設置されております。\n\n<span class=${className}>※JR東日本</span>の利用をお薦めです。<span class=${className}>成田空港駅</span>から降車してください。`,
      narita2_shop: (className: string) =>
        `WAmazing免税ロッカーは、<span class=${className}>成田空港第2ターミナルJR空港第2ビル駅</span>に設置されております。\n\n※<span class=${className}>JR東日本</span>の利用をお薦めです。<span class=${className}>空港第2ビル駅</span>から降車してください。`,
      new_chitose_shop: (className: string) =>
        `WAmazing免税ロッカーは、<span class=${className}>新千歳空港-国際ターミナルエリア1F</span>に設置されております。\n\n※JR駅からロッカーまでおよそ<span class=${className}>10分間</span>かかります。時間の余裕を持って、受取りに行って下さい。`,
      sendai_shop: (className: string) =>
        `WAmazing受取りロッカーは、『仙台国際空港』<span class=${className}>1Fの国際到着ロビー</span>に設置されております。`,
      tenjin_shop: (className: string) =>
        `WAmazing免税ロッカーは、<span class=${className}>天神バスターミナ3F-降車場方面</span>に設置されております。\n\n\n※<span class=${className}>西日本鉄道(西鉄)</span>の利用をお薦めです。<span class=${className}>西鉄天神駅</span>から降車してください。`
    },
    messages: {
      earliestPickupDate: `受け取れる一番早い日付`,
      minimumPickUpTime: (year: string, month: string, day: string, hour: string, minute: string, className: string) =>
        `最速で受取り可能な時間：<span class=${className}>${year}年${month}月${day}日 ${hour}時${minute}分から</span>`,
      minimumPickUpTimeSp: (
        year: string,
        month: string,
        day: string,
        hour: string,
        minute: string,
        className: string
      ) =>
        `<span class=${className}>受取可能時間</span><span>${year}年${month}月${day}日 ${hour}時${minute}分から</span>`
    },
    naha_shop: {
      listPickupLocation: `那覇空港受取り案内地図`,
      lockersLocation: `那覇空港2F`,
      routeInformationByDomestic: `経路案内(国内線からのルート)`,
      routeInformationByInternational: `経路案内(国際線からのルート)`,
      route: {
        domestic: {
          step1: `①2階の国際線ゲートのDに向けて進めてください。`,
          step2: `②ゲートDの前で左側に曲がってください。トイレが目印です。`,
          step3: `③突き当たりで左側に向けるとロッカーがあります。`
        },
        international: {
          step1: `①ビジターサービスセンターに向けて進めてください。右側のエスカレーターに乗って2階に進めてください。`,
          step2: `②降りてすぐ左側に向けるとロッカーがあります。`
        }
      }
    },
    narita1_shop: {
      listPickupLocation: `成田空港駅の受取り案内地図`,
      lockersLocation: `成田空港駅の案内地図`,
      routeInformationByJR: `経路案内(JR東日本の成田空港駅を利用する方へ)`,
      routeInformationByKeisei: `経路案内(京成線を利用する方へ)`,
      route: {
        finish: (routeNumber: string) => `${routeNumber}楽しい、楽な免税買物を体験しましょう！`,
        busTaxi: {
          step1: `①降車後、JRの改札に向かってお進みください。`,
          step2: `②JRのチケット販売機にて150円のチケットをご購入の上、改札を通ってください。`,
          step3: `③待合室の方に向かっていくと右側にWAmazingロッカーがあります。`
        },
        jr: {
          step1: `①降車後、エスカレーターにのり上がってください。`,
          step2: `②出口の方にお進みください。`,
          step3: `③出口に向かって左側にWAmazingロッカーがあります。`
        },
        keisei: {
          step1: `①降車後、エスカレーターにのり上がって出口に向かってください。`,
          step2: `②出口を出てJRの改札口に向かって左にぐるっと回ってください。`,
          step3: `③JRのチケット販売機にて150円のチケットをご購入の上、改札を通ってください。`,
          step4: `④待合室の方に向かっていくと右側にWAmazingロッカーがあります。`,
          ticket: `※チケットの購入方法\n注意：商品を受け取って改札口を出る際は駅員さんに「入場券として使用しました」とお伝えしてください。`
        }
      }
    },
    narita2_shop: {
      listPickupLocation: `成田空港第2ビル駅の受取り案内地図`,
      lockersLocation: `成田空港第２ビル駅の案内地図`,
      routeInformationByJR: `経路案内(JR東日本の空港第2ビル駅を利用する方へ)`,
      routeInformationKeisei: `経路案内(京成線を利用する方へ)`,
      route: {
        busTaxi: {
          step1: `①降車後、JRの改札に向かってお進みください。`,
          step2: `②JRの改札口にお進み、JRの有人チケット売り場にて入場券をご購入ください。`,
          step3: `③JRの改札口に入り、トイレに向かって右側にWAmazingロッカーがあります。`
        },
        jr: {
          step1: `①降車後、エスカレーターにのり上がってください。`,
          step2: `②改札口の反対側のトイレの方にお進みください。`,
          step3: `③トイレに向かって右側にWAmazingロッカーがあります。`
        },
        keisei: {
          step1: `①降車後、エスカレーターにのり上がってください。`,
          step2: `②改札口を出て左にお進みください。`,
          step3: `③第2、３ターミナルの方面に向かってください。`,
          step4: `④JRの改札口にお進み、JRの有人チケット売り場にて入場券をご購入ください。`,
          step5: `⑤JRの改札口に入り、トイレに向かって右側にWAmazingロッカーがあります。`,
          ticket: `\n※入場券のサンプルイメージ`
        }
      }
    },
    new_chitose_shop: {
      listPickupLocation: `新千歳空港の受取り案内地図`,
      lockersLocation: `新千歳空港- 1F`,
      routeInformationByBusTaxi: `経路案内(バス、タクシーを利用する方へ)`,
      routeInformationByTrain: `経路案内(電車を利用する方へ)`,
      route: {
        busTaxi: {
          step1: `①降車後、ターミナルビルに入って、2階まで上がって頂きながら、「国際線」のサインに従い進んでください。`,
          step2: `②引き続き「国際線」のサインに従い、道の一番奥まで直進しでください。`,
          step3: `③突き当たり左に曲がってお進みください。`,
          step4: `④コンビニを経過し、道の突き当たり右に曲がってください。`,
          step5: `⑤突き当たりのエレベーターを利用し、１Fまで下がってください。`,
          step6: `⑥エレベーターに降りて、左手前に向かってください。`,
          step7: `⑦直進するとWAmazingの免税ロッカーは右側になります。楽しい、楽な免税買物を体験しましょう！`
        },
        train: {
          step1: `①降車後、改札口から出てすぐ、手前のエレベーターを利用して、２Fまで上がってください。`,
          step2: `②エレベーターから降りて、「国際線」方面へ向かって直進してください。`,
          step3: `③「国際線」サインに向かい、道の一番奥まで直進してください。`,
          step4: `④突き当たり左に曲がってお進みください。`,
          step5: `⑤コンビニを経過し、道の突き当たり右に曲がってください。`,
          step6: `⑥突き当たりのエレベーターを利用し、１Fまで下がってください。`,
          step7: `⑦エレベーターに降りて、左手前に向かってください。`,
          step8: `⑧直進するとWAmazingの免税ロッカーは右側になります。楽しい、楽な免税買物を体験しましょう！`
        }
      }
    },
    notice: {
      aboutOrder: `配送時間が3日間以上必要なため、前もって購入してくださいませ。`
    },
    sendai_shop: {
      listPickupLocation: `仙台国際空港での受取り案内地図`,
      lockersLocation: `1Fの国際到着ロビー`,
      routeInformationByInternational: `経路案内(国際線からのルート)`,
      routeInformationUseSdj: `経路案内(仙台国際空港駅を利用する方へ)`,
      route: {
        international: {
          step1: `①国際線到着後の出口のすぐ左側にロッカーが設置されております。`
        },
        sdjInternational: {
          step1: `①改札口を出てすぐ右の通路へ進めてください。`,
          step2: `②通路の一番奥まで進み、掲示板通りに左の通とへ曲がり進めてください。`,
          step3: `③通路の一番奥まで進み、出口の右手へ進めてください`,
          step4: `④右手に見えるエスカレーターに乗り、１階まで降りてください`,
          step5: `⑤1階に降りて、左前の国際線到着ロビーへ進めてください。`,
          step6: `⑥突き当りの左側にロッカーが設置されております。`
        }
      }
    },
    tableHeader: {
      receivableDate: `受取可能日`,
      shopName: `受取り場所名`
    },
    tenjin_shop: {
      listPickupLocation: `天神バスターミナル- 3F`,
      lockersLocation: `天神バスターミナル受取り案内地図`,
      routeInfomation: `経路案内(西鉄天神駅を利用する方へ)`,
      route: {
        step1: `①降車後、北改札口から出て、左へ曲がってください。`,
        step2: `②「高速バス（到着）」サインに従い、降り場方面に進みください。`,
        step3: `③エレベーターを利用し、3Fまで上がってください。`,
        step4: `④エレベーターから降りて、反対側の方向に向かってください。（インフォメーションを経過します）`,
        step5: `⑤そのまま直行すると、突き当たりのWAmazingロッカーが見えます。`,
        step6: `⑥楽しい、楽な免税買物を体験しましょう！`
      }
    }
  },
  staticWalkthrough: {
    description: `ワメイジングの紹介ページ。日本のお土産を購入するならワメイジングをご利用ください。購入した商品は、日本旅行の際に指定空港で受け取ることができます。日本の人気コスメやお菓子を豊富に取り揃えております。`,
    heading: `ワメイジングとは？`,
    pickupsSectionHeading: `受取り場所名`,
    safeAndConveneientShoppingService: (className: string) =>
      `オンラインショップで商品を予約し、ご利用される<span class=${className}>日本の空港で商品を受け取れる </span>「安心・便利な免税買い物サービス」です。`,
    serviceBenefitsHeading: `サービスのメリット`,
    serviceBenefitsSubheading: `旅行中の買い物に関するいろんなトラブルを簡単に解消します。限られた時間を有効活用してより日本を楽しんでください。`,
    title: `サービス紹介`,
    aboutPurchase: {
      btn: `「日本の免税制度」を確認する`,
      heading: `免税購入について`,
      listItem1: `・一回の購入は5,000円（税抜）以上で、免税可能 \n`,
      listItem2: `・免税手続きは短期在留ビザのお客様のみに対応`,
      listItem3: `・1人は1日最大50万円までの免税品を購入可能`,
      listItem4: `・受け取りひは3日前に注文してください。`
    },
    banner: {
      banner1: {
        text: `おすすめ人気化粧品`,
        title: `安心できる`
      },
      banner2: {
        text: `おすすめ人気お菓子`,
        title: `絶対買いたい`
      }
    },
    faqs: {
      answer1: `いつでも受け取れますのでご安心ください。`,
      answer2: `オンライン決済になります。\n現状対応しているクレジットカードのブランドは、VISA 、Mastercard、JCB、American Express となります。\nwechatpayを利用しているユーザーは受取る時に、残額決済もwechatpayになります。`,
      answer3: `変更不可となります。キャンセルしてから買い直してください。`,
      answer4: `・決済の実施において、通信環境が必要となります。お客様にて通信環境をご用意頂けますようお願い致します\n・購入予約者ご本人様のみがお手続きを実施頂けます。必ず購入予約者ご本人様がお越しください\n・お手続きには購入予約者ご本人様のパスポート、及び当該パスポートに貼付された上陸許可証印シールが必要となります。必ずご持参ください。\n　　　なお、パスポートはIC対応の物に限ります。また、上陸許可証印シールは有効期限内の現物に限ります\n・お手続きにおいて、購入予約者ご本人様の顔を撮影させて頂きます。予めご了承ください\n・受取時にクレジットカードでの決済が必要です。利用上限額にご注意ください。`,
      btn: `すべてのガイドを確認する`,
      heading: `よくあるお質問`,
      question1: `出国日以外の日程に受け取れますか？`,
      question2: `どうやって支払うのでしょうか？`,
      question3: `受取日変更できますか？`,
      question4: `商品を受け取る際に必要なものはなんですか？`
    },
    serviceBenefits: {
      issueLink: `受け取れなかった場合はこちら`,
      card1: {
        body: (className: string) =>
          `言葉が通じないのでどこで販売しているか<span class=${className}>店探しも </span>、雨が降っていると<span class=${className}>濡れるのも </span>、行列に<span class=${className}> 並ぶのも</span>、ちょっと大変だと思うあなたにピッタリ`,
        footer: `ネットで簡単注文`,
        title: `店探して行くのが大変`
      },
      card2: {
        body: (className: string) =>
          `楽しかった分、買いすぎて<span class=${className}> 持ち歩くのが大変</span>、まだ日程あるのにこれらを持って<span class=${className}>電車乗るのが大変 </span>、<span class=${className}> 頼まれた物</span>だから余計に大変に感じると思うあなたにピッタリ`,
        footer: `空港で受け取るから楽`,
        title: `持ち歩きが大変`
      },
      card3: {
        body: (className: string) =>
          `<span class=${className}> 免税ができないショップ、言葉が通じないショップ、免税手数料のあるショップ</span> など免税するのは大変だと思うあなたにピッタリ`,
        footer: `免税確認が簡単`,
        title: `免税手続きが不安`
      },
      card4: {
        body: (className: string) =>
          `人出の多いところは<span class=${className}> まだ不安</span>、できるだけ<span class=${className}> 接触は控えたい</span>、無駄な<span class=${className}>コミュニケーションは避けたい </span>、できるだけ色んな<span class=${className}> リスクは減らしたい</span>と思うあなたにピッタリ`,
        footer: `受け取りが非対面で安心`,
        title: `接触はまだ不安`
      },
      card5: {
        body: (className: string) =>
          `パッケージ旅行なので、ルートが決まって<span class=${className}>ショッピングする時間がない </span>。<span class=${className}> ツアー会社のショッピングセンター</span>しかいけないと不満を感じるあなたにピッタリ`,
        footer: `パッケージ旅行にもピッタリ`,
        title: `自由時間がない`
      },
      card6: {
        body: (className: string) =>
          `よく見ると<span class=${className}>ちょっと違う「これって本物？」 </span>、お土産なので偽物で恥をかきたくない、安心できるところで購入したい、と心配しているあなたにピッタリ`,
        footer: `正規品で安心`,
        title: `偽物なのか心配`
      },
      card7: {
        body: (className: string) =>
          `日程を間違えて<span class=${className}> 商品を受け取れなかった</span>、受け取る場所を間違えて<span class=${className}>商品を受け取れなかった </span>、という万が一の時が心配のあなたにピッタリ`,
        footer: `充実なサポートで安心`,
        title: `もしものことが心配`
      }
    },
    serviceUsageFlow: {
      heading: `サービス利用流れ`,
      usageCard1: {
        body: `定番のお土産はもちろん、日本全国からかき集めた地域限定のお土産までネットで簡単にピックアップ！`,
        title: `ネットでショッピング`
      },
      usageCard2: {
        body: `買いたい商品価格の20%金額で、簡単に商品を予約できる！`,
        title: `予約手数料を支払う`
      },
      usageCard3: {
        body: `受取場所で、残額の80%を支払い、免税資格確認後にすぐ商品を受け取れる！`,
        title: `受取場所で\n決済して受取り`
      }
    }
  },
  systemMaintenance: {
    text: `9/26（木）4:30〜5:30（JST）の間、システムメンテナンスを実施します。この間WAmazing ShopはWeb・アプリともにご利用いただけません。`
  },
  taxFreeGuide: {
    description: (className: string) =>
      `せっかくの楽しい日本への旅行！おしゃれなスポットや歴史ある観光地はもちろん楽しみではあるが、日本でのショッピングももちろん楽しみ！しかもせっかくだから<span class=${className}>免税して安くショッピングもしたい！</span>\nしかし、「コミュニケーションがうまく取れるか心配」「免税の条件はどうなの？」「失敗して悲しい思い出を残したくない」と思うあなたに！<span class=${className}>日本の免税手続きはどうなのか</span>確認しておかなければならない失敗しない。日本の免税店でのショッピングを把握して楽しい思い出を増やしもしょう`,
    title: `日本の免税案内`,
    TaxExemption: {
      heading: `日本の免税制度とは`,
      Item1: {
        description: `有効な６ヶ月未満の短期在留資格を持っている外国の方は免税対象になります。免税手続きに、有効な短期在留上陸許可シールが貼っているパスポートが必要です。`,
        title: `短期在留資格の方が免税対象`
      },
      Item2: {
        description: `一回の購入合計金額は5000円以上で、免税価格で商品を購入可能。\n消耗品購入の場合、同一店舗で１日50万(税抜)以下の購入制限があります。`,
        title: `5,000円以上の買い物は免税可能`
      },
      Item3: {
        description: `一部の軽減税率に適用する商品の税率は8%になります。`,
        title: `10%の消費税は直接免除可能`
      }
    },
    dutyFree: {
      description: `Tax-free shopマークが付いているオンラインショップ、ドラックストア、デパートやコンビニなどの店舗で免税買い物が可能です。`,
      heading: `日本で免税商品を\n購入できるお店は？`,
      card1: {
        d1: `免税手続き`,
        d2: `ネットで簡単`,
        d3: `非対面`,
        d4: `非対面で安心`,
        d5: `手軽さ`,
        d6: `空港まで配送するので\n楽\n`,
        description: (className: string) =>
          `言葉が通じないのでどこで販売しているか<span class=${className}>店探しも</span>、雨が降った時の<span class=${className}>濡れるのも</span>、<span class=${className}>行列に並ぶのも</span>、ちょっと<span class=${className}>大変だ</span>と思うあなたにピッタリ`,
        heading: `オンラインショップ`
      },
      card2: {
        d1: `免税手続き`,
        d2: `その場で可能`,
        d3: `非対面`,
        d4: `対面`,
        d5: `手軽さ`,
        d6: `荷物の持ち運び\nが必要`,
        description: (className: string) =>
          `楽しかった分、買いすぎて<span class=${className}>持ち歩くのが大変</span>、まだ日程があるのにこれらを持って<span class=${className}>電車乗るのが大変</span>、<span class=${className}>頼まれた物</span>がから余計に<span class=${className}>大変</span>に感じるあなたにぴったり`,
        heading: `ドラッグストア`
      },
      card3: {
        d1: `免税手続き`,
        d2: `時間がかかる`,
        d3: `非対面`,
        d4: `対面`,
        d5: `手軽さ`,
        d6: `荷物の持ち運び\nが必要`,
        description: (className: string) =>
          `<span class=${className}>免税ができていないショップ、言葉が通じないショップ、免税手数料がかかるショップ</span> など、免税手続きが大変だと思うあなたにピッタリ`,
        heading: `デパート`
      }
    },
    dutyFreeFlow: {
      heading: `オンライン免税ショップの\n購入流れを確認する`
    },
    dutyFreePrecautions: {
      heading: `日本の免税商品に関する注意事項`,
      info: `・消耗品に該当する免税商品は、日本国内で包装を開けて使うことはできません。\n・免税商品を出国前に他人に譲渡してはいけません。\n・飲料、調味料、化粧品などの液体物は、機内持ち込み制限が適用されます。\n・免税品を海外へ郵送する場合は、郵便局が発行する引受証・発送伝票などの控えを税関に提出する必要があります。\n・免税品は購入者本人が国外へ持ち出さなければいけません。`
    },
    faqs: {
      answer1: `DUTY FREE：関税法に基づく免税の仕組みで、消費税・関税・酒税・たばこ税が免税対象となる。主に国際空港の出国エリアに存在。\nTAX FREE：消費税法に基づく免税の仕組みで、一般購入可能な物品・消耗品が対象となる。街のショッピングエリアにある免税店を指す。`,
      answer2: `新しい制度では、「パスポート」「購入した免税商品」の２点が必要になります。\n`,
      answer3: `できません。免税手続きは購入日当日のみ可能です。`,
      answer4: `国審査時に自動化ゲートを利用するとパスポートに入国証印が押されず、免税手続きができなくなる恐れがあります。免税店を利用する場合は、事前に入国管理局に証印が必要な旨を伝えましょう。`,
      answer5: `液体物の機内持ち込みは100ml以下が限度で、それ以上の容量は持ち込みできません。ただし下記の条件を満たす場合は持ち込みが可能になります。\n・スーツケースに入れて手荷物カウンターに預ける場合\n・出国エリアで液体物の免税商品を購入する場合（※直行便を利用する場合）`,
      answer6: `免税手続きができるのは購入者本人のみになります。`,
      answer7: `購入した商品は本人が海外へ持ち出す義務があります。`,
      heading: `免税手続きによくある質問`,
      question1: `DUTY FREE」と「TAX FREE」の違いは？`,
      question2: `免税手続きをするときに必要なものは？`,
      question3: `商品購入後、翌日以降に免税手続きができますか？`,
      question4: `自動化ゲートを利用した場合、免税制度は利用可能ですか？`,
      question5: `購入した免税商品が液体物の場合、機内持ち込みは可能ですか？`,
      question6: `免税手続きは他の人にお願いしてもいいですか？`,
      question7: `免税商品を他の人に渡して、海外へ持ち出すことはできますか？`
    },
    meta: {
      description: `免税手続きについて | 免税買い物について | 日本免税店について 。日本旅行のお土産をもっと楽に、お得に買うなら、WAmazingオンライン免税店！`,
      title: `タックスフリーガイド`
    },
    products: {
      description: `基本的にTax-free shopマークが付いているオンラインショップ、ドラックストア、デパートやコンビニなどの店舗で免税買い物が可能です。`,
      heading: `日本で免税可能な商品は？`,
      card1: {
        info: `※１人の免税対象者に対して、同じ店舗における１日の販売合計額が５千円以上であること\n ※日本国内で利用可能、入国６ヶ月以内に持ち出す必要がある`,
        item1: `アクセサリー`,
        item2: `服`,
        item3: `カバン`,
        item4: `靴`,
        item5: `家電製品`,
        item6: `カメラ`,
        item7: `時計`,
        title: `日本で免税可能な一般商品`
      },
      card2: {
        info: `※１人の免税対象者に対して同じ店舗における１日の販売合計額が５千円以上、50万円以下の範囲内であること \n※日本国内で利用不可、入国６ヶ月以内に持ち出す必要がある`,
        item1: `化粧品`,
        item2: `食品`,
        item3: `お酒`,
        item4: `タバコ`,
        item5: `保健食品`,
        item6: `医薬品`,
        title: `日本で免税可能な消耗商品`
      }
    }
  },
  taxFreeShop: {
    article1: `第1條（條款的適用）`,
    article10: `第10條（本網站及本服務的暫時停止）`,
    article10Sentence1: `在下述各項的情況下，本公司可以不事先通知會員而暫時停止運營本網站及本免稅EC服務：`,
    article10Sentence2: `（1）進行本網站的維護或設計變更時；`,
    article10Sentence3: `（2）發生或有可能發生自然災害或其他緊急情況、導致無法運營本網站及本免稅EC服務時；`,
    article10Sentence4: `（3）其他本公司判斷因不得已的事由需要暫時停止運營本網站及本免稅EC服務時。`,
    article11: `第11條（本公司的免責）`,
    article11Sentence1: `1. 因自然災害、線路擁堵、機器故障或維護導致的停機、商品供應商的信息丟失、或因第三方導致的信息篡改或洩露等原因產生的損害，除損害是因歸責於本公司的事由造成的，本公司概不負責。`,
    article11Sentence2: `2. 即使在本公司就會員對本免稅EC服務的使用相關負責的情況下，除本公司的故意或重大過失外，本公司的責任僅限於直接且普通的損害。`,
    article12: `第12條（準據法、語言、管轄法院）`,
    article12Sentence1: `1. 本免稅EC服務使用條款以日本法為準據法，並按日本法予以解釋。`,
    article12Sentence2: `2. 本免稅EC服務使用條款以日語為正文，並按日語予以解釋和簽訂。本免稅EC服務使用條款除日語之外的其他語言的翻譯版本僅作參考之用，不對以日語對本免稅EC服務使用條款進行的解釋作任何變更。`,
    article12Sentence3: `3. 就本免稅EC服務使用條款產生的糾紛的第一審專屬管轄法院為東京地方法院。`,
    article1Sentence1: `1. 本免稅EC服務使用條款適用於通過WAmazing株式會社（以下簡稱“本公司“）管理的網站（以下統稱“本網站“）進行會員註冊的會員使用本免稅EC服務（參照下條的定義）時進行的一切行為，會員應在同意本免稅EC服務使用條款後使用本免稅EC服務。`,
    article1Sentence2: `2. 如本公司於本免稅EC服務中對各注意事項等（以下簡稱“各注意事項等“）進行了提示的，各注意事項等分別構成本免稅EC服務使用條款的一部分。`,
    article1Sentence3: `3. 本公司可無需事先通知會員而隨時修改本免稅EC服務使用條款，本公司修改後的本免稅EC服務使用條款於刊載在本公司指定網站之時（如對本公司修改後的本免稅EC服務使用條款的生效日有另行設定的，以該另行設定之日為準）發生效力。會員在修改後使用本免稅EC服務的，視為同意修改後的本免稅EC服務使用條款。`,
    article2: `第2條（本免稅EC服務的定義及買賣預約合同的成立）`,
    article2Sentence1: `1. 本免稅EC服務是指，會員自發地通過本網站使用能達成以下目的的服務：`,
    article2Sentence2: `① 購買及預約購買本公司在本網站上刊載的商品`,
    article2Sentence3: `2. 會員可在本網站上通過以下方式進行商品購買的預約：`,
    article2Sentence4: `① 會員完成在本網站上輸入本公司指定的必要信息（包括客戶信息、訂單信息、支付信息等）、在本網站上申請商品的預約購買、並支付第4條規定的預約手續費的同時，預約完成。此外，在本網站上完成預約的時刻，本公司和會員之間就該商品的買賣預約合同（以下簡稱“買賣預約合同“）同時成立。`,
    article2Sentence5: `3. 可預約期間為本網站上公示的期間。`,
    article2Sentence6: `4. 為證明買賣預約合同的成立，本公司將在本網站內的會員頁面發送「買賣預約合同成立畫面」。`,
    article2Sentence7: `5. 本公司和會員之間根據本條規定成立買賣預約合同的，視為會員已接受自行承擔第5條規定的取消費用等的義務。`,
    article3: `第3條（商品價格的變更等）`,
    article3Sentence1: `1. 會員知曉，本網站上刊載的關於商品價格等的信息可能會與其他媒體提供的信息有所差異。`,
    article3Sentence2: `2. 會員知曉，商品價格等可能會不經預告地進行變更。變更後的商品價格等只對於變更後申請預約的會員適用，在變更前已進行了預約申請的會員適用變更前的商品價格等。`,
    article4: `第4條（商品預約手續費的支付）`,
    article4Sentence1: `會員應在進行商品的購買預約時向本公司支付相當於該商品價格的20%作為預約手續費（預約手續費中含消費稅）。但，商品頁面等中另有說明的，應從其說明。此外，會員取消或購入已預約商品之前均無權要求退還預約手續費。`,
    article5: `第5條（預約取消的成立和取消費用的產生）`,
    article5Sentence1: `1. 會員可在購買預約時指定的收貨日當天之前，根據買賣預約合同取消全部預約商品的購買預約。但，此種情況下，會員只能一次性取消全部商品的預約、不能僅取消部分商品的預約。`,
    article5Sentence2: `2. 會員在商品向指定收貨地點發貨前取消商品的購買預約的，就該商品的取消不產生取消費用。此種情況下，本公司根據上條進行預約手續費的退款處理。`,
    article5Sentence3: `3. 會員在商品向指定收貨地點發貨後取消商品的購買預約，將產生預約手續費全額的取消費用。但，商品頁面等中另有說明的，應從其說明。`,
    article5Sentence4: `4. 會員在購買預約時指定的收貨日當天之前沒有對已預約商品進行購買或取消的意思表示的，視為會員取消該商品的預約，併產生預約手續費全額的取消費用。但，商品頁面等中另有說明的，應從其說明。`,
    article5Sentence5: `5. 即使會員不希望取消預約，但本公司根據會員就本免稅EC服務使用相關的預約內容判斷其違反了法律法規等規定或可合理地判斷為不適當的，本公司有權取消該預約。此種情況下的取消費用及退款處理根據上述各款執行。`,
    article6: `第6條（買賣合同的成立、商品價格的確定及商品的交付）`,
    article6Sentence1: `1. 選擇在本公司櫃檯收貨的\n會員應在購買預約時指定的收貨日、於購買預約時指定的收貨地點的本公司櫃檯的營業時間內到店、對本公司進行購買已預約商品的意思表示，並完成本公司指定的手續時，會員與本公司之間就該商品的買賣合同成立，本公司對會員交付該商品。`,
    article6Sentence2: `2. 選擇在儲物櫃收貨的\n會員應在購買預約時指定的收貨日、於購買預約時指定的收貨地點所在的儲物櫃對本公司表明進行購買已預約商品的意思，並根據本公司指定的手續操作完成時，會員與本公司之間就該商品的買賣合同成立，本公司對會員交付該商品。`,
    article6Sentence3: `3. 本公司應將第4條的預約手續費抵作買賣合同成立後商品的價款。`,
    article6Sentence4: `4. 會員在購買預約時指定的收貨日當天之前沒有對已預約商品進行購買或取消的意思表示的，本公司將其視為會員取消該商品的預約，此種情況的取消費用根據上條規定執行。`,
    article7: `第7條（會員的遵守事項）`,
    article7Sentence1: `1. 未經本公司同意，會員不得將通過使用本網站獲得的信息以個人使用以外的目的進行複製、傳播等，也不得以任何形式提供給第三方使用。`,
    article7Sentence10: `（8）拒不支付本公司請求的預約手續費、取消費用或商品價款的行為（無論理由為何）；`,
    article7Sentence11: `（9）對本公司或第三方的暴力或騷擾行為；`,
    article7Sentence12: `（10）被認定為以向他人轉賣或以商用為目的的預約行為；`,
    article7Sentence13: `（11）其他任何違反或可能違反法律法規的行為。`,
    article7Sentence14: `3. 如本公司或第三方因會員做出的前款各項的任一行為遭受損害的，會員應承擔全部法律責任，不得對本公司及第三者造成任何損害。`,
    article7Sentence15: `4. 如會員不滿足法律法規等規定的就商品購買免征消費稅的條件，但仍向本公司進行了購買已預約商品的意思表示的，除了該商品的價款外，會員應另行向本公司支付相當於該商品的消費稅金額。`,
    article7Sentence16: `5. 本公司根據第8條第1款取消了本免稅EC服務使用相關的預約的，會員應根據第5條的規定支付取消費用。`,
    article7Sentence17: `6. 如會員為未成年人，應取得法定代理人的同意後進行預約。如會員謊稱其得到了法定代理人的同意或謊稱其為成年人，其進行的預約行為也不能被取消。`,
    article7Sentence2: `2. 在使用本免稅EC服務時，會員不得有如下行為：`,
    article7Sentence3: `（1）冒充第三方發送或填寫信息的行為；`,
    article7Sentence4: `（2）以本公司許可以外的方式使用本免稅EC服務的行為；`,
    article7Sentence5: `（3）發送或寫入有害計算機程序的行為，發送廣告郵件、連環信件、垃圾郵件等行為；`,
    article7Sentence6: `（4）侵害或可能侵害本公司或第三方的著作權及其他知識產權的行為；`,
    article7Sentence7: `（5）對本公司及第三方進行誹謗、中傷或損害名譽的行為；`,
    article7Sentence8: `（6）向他人公開違反公序良俗的信息、文件及圖像等的行為；`,
    article7Sentence9: `（7）無論是否故意，提供虛假或不完整的本免稅EC服務的用戶或會員個人的姓名、住所、電話號碼、郵箱地址、信用卡號碼等信息進行註冊的行為；`,
    article8: `第8條（會員遵守事項的違反）`,
    article8Sentence1: `1. 如會員違反上條規定的遵守事項或有其他被本公司判斷為對本免稅EC服務的運營上不利的情況的，本公司有權採取制止該行為、取消該會員與本公司的買賣預約合同或買賣合同、停止含本免稅EC服務在內的與本網站相關的一切服務的使用、剝奪其會員資格或要求賠償損失等必要的措施（包括法律措施）。`,
    article8Sentence2: `2. 如本公司推測會員違反上條規定的遵守事項或有其他被本公司判斷為對本免稅EC服務的運營上不利的情況的，可向會員確認該行為的詳細情況。`,
    article9: `第9條（著作權）`,
    article9Sentence1: `1. 未經本公司事前同意，會員不得將通過使用本網站獲得的全部內容以著作權規定的會員個人使用以外的目的進行使用。`,
    article9Sentence2: `2. 如因違反本條規定產生糾紛的，會員應自行承擔費用和責任解決該糾紛，且不得給本公司及第三方造成任何損害。`,
    mainTitle: `WAmazing免稅EC服務使用條款【用於購買商品時_普通稅收方案】`
  },
  vendor: {
    sugi: `スギ薬局 川口戸塚店`,
    tokyu: `東急百貨店`,
    wamazing: `WAmazing買物`
  },
  wonderCompass: {
    discoverTheCharmOfJapan: (className: string) =>
      `免税商品の受け取り体験をしていただいた方全員に、\n<span class=${className}>日本の人気お土産をプレゼント！</span>\n現地で日本全国各地のお土産をゲットして、日本の魅力を感じよう！`,
    justThreeMins: `簡単３分`,
    location: `WANDER COMPASS SHIBUYAは渋谷109の隣、\n渋谷駅A2出口の地下通路にあります。`,
    overview: `開催概要`,
    title: `2023年9月30日まで現場の受取体験実施！`,
    contents: {
      address: `住所：Shibuya Station B1 floor, 2 Chome-1-1 Dōgenzaka, Shibuya-ku, Tokyo`,
      period: `期間：2023/8/1〜2023/9/30`,
      place: `場所：WANDER COMPASS SHIBUYA`,
      time: `時間：10:00〜20:00`
    }
  },
  yamazakiGift: {
    period: `4/8（火）～4/21（月）の期間内のご注文\n\n5/1（木）～5/31（土）の期間内のお受け取り　`,
    promotionDetails: `今なら 3万円以上ご購入＆指定の10%割引クーポンをかごに入れた方の中から、合計20名様に大人気ウィスキー「山崎ウィスキー」をプレゼントいたします！`,
    conditions: {
      text1: `3万円以上のお買い物`,
      text2: `指定の10%割引クーポンを使用（クーポンをかごに入れて適用してください）`
    },
    entryBotton: {
      text1: `エントリ済み`,
      text2: `カート画面にて専用クーポンコードを入力してください`,
      text3: `クーポンの利用方法`,
      text4: `このボタンをクリックしてね！`
    },
    meta: {
      title: `★3万円以上のご購入でチャンス！合計20名様に「山崎ウィスキー」プレゼント★`
    },
    modal: {
      title: `エントリーありがとうございます`
    },
    notes: {
      list1: `抽選の対象となるのは クーポンを適用したご注文のみです。`,
      list2: `クーポンは、医薬品とお酒には適用できません。`,
      list3: `注文後にキャンセルをされた場合には、抽選の対象となりません。`,
      list4: `注文成立後、商品内容、受け取り場所、受け取り時間の変更は不可となります。変更の際はキャンセル後に再度注文していただく必要があります。`,
      list5: `期間中、おひとりで複数回購入された場合でも、当選は最大で1つのみとなります。`,
      list6: `機内持ち込みおよびご帰国時の持ち帰りについては、各国の税関規定や航空会社の手荷物規則により制限がございます。お客様ご自身の責任において、事前にご確認のうえお手続きくださいますようお願いいたします。当店では、持ち込み・持ち帰りに関する責任は負いかねますので、予めご了承ください。`,
      list7: `もし完美行側の責任にて商品の受け取りができなかった場合、プレゼントのウィスキーは、次回ご利用いただける5千円割引クーポン（1万円以上の購入に適用、医薬品と酒類は除く）に変更させていただきます。\n\nまた、元々ご購入いただいた商品は、返金または国際郵便でのお届けのいずれかの方法で対応させていただきます。詳細については、後日担当者よりご連絡し、確認させていただきます。\n`,
      list8: `本キャンペーンは予告なく変更・終了する場合があります。`,
      list9: `本キャンペーンの最終解釈権は当社が保有します。`
    },
    prize: {
      list1: `当選者には、受取日の3日前までにご連絡いたします。`,
      list2: `プレゼントはご注文いただいた他の商品と同梱いたします。`,
      list3: `ご連絡がつかない場合でも、プレゼントは一緒にご注文いただいた商品と一緒に免税袋に同梱をさせていただきます。`
    }
  },
  yearEndSale: {
    metaDescription: `【最大20％OFF】年末年始を彩るお得な商品がもりだくさん！！`,
    metaTitle: `歳末＆新春大感謝祭！`,
    popularProductsTitle: `人気商品`,
    startShopping: `人気商品を今すぐ確認！`
  }
} as const;
